<template>
  <div class="project-container" v-loading="loading">
    <el-row class="header">
      <el-col :span="16">
        <div class="project-info">
          <span>{{project.name}}</span>
          <el-popover
            placement="bottom"
            title="项目说明"
            trigger="hover"
            :content="project.explain">
            <i slot="reference" class="el-icon-info"></i>
          </el-popover>

        </div>
        <div class="project-tab">
          <el-tabs v-model="tabName">
            <el-tab-pane label="事项" name="tab1"></el-tab-pane>
            <el-tab-pane label="动态" name="tab2"></el-tab-pane>
            <el-tab-pane label="文件" name="tab3"></el-tab-pane>
            <el-tab-pane label="概览" name="tab4"></el-tab-pane>
            <el-tab-pane label="统计" name="tab5"></el-tab-pane>
            <el-tab-pane label="甘特图" name="tab6"></el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="8" class="right-menu">
        <div class="team-info" @click="teamVisible=true">
          <el-tooltip effect="dark" :content="project.username" placement="bottom">
            <el-avatar size="small" :src="project.userphoto"></el-avatar>
          </el-tooltip>
          <el-tooltip v-for="(u,indx) in project.teamlist" v-if="indx<2" effect="dark" :content="u.name" placement="bottom">
            <el-avatar size="small" :src="u.photo"></el-avatar>
          </el-tooltip>
          <el-tooltip effect="dark" :content="projectTeamAllname" placement="bottom">
            <el-button size="mini" type="primary" icon="el-icon-more" plain circle></el-button>
          </el-tooltip>
        </div>
        <el-divider direction="vertical"></el-divider>
        <span class="set-btn" @click="projectInfoVisible=true"><i class="el-icon-setting"></i> 项目设置</span>
      </el-col>
    </el-row>
    <div class="task-box" v-show="tabName==='tab1'">
      <div class="task-top">
        <div class="task-top-left">
          <el-checkbox v-model="showUnopened">显示未开启事项</el-checkbox>
        </div>
        <div class="task-top-right">
          <el-input placeholder="输入关键字" size="mini" @input="searchTask" prefix-icon="el-icon-search" v-model="search"></el-input>
<!--          <div class="top-filter"><i class="el-icon-finished"></i> <el-badge is-dot class="item">筛选</el-badge></div>-->
        </div>
      </div>
      <div class="task-panel">
        <div class="panel-list" :style="`width:${stagelist.length*320-24+30}px`">
          <div class="panel-item" v-for="s in stagelist">
            <div class="task-stage">
              <div class="tit">{{s.stagename}}</div>
              <el-dropdown class="btn" trigger="click" size="small">
                <i class="el-icon-more"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="s.psid!==0&&s.psid!==-1&&isadmin" @click.native="editStage(s,s.xh)"><i class="el-icon-edit"></i> 编辑此阶段名称</el-dropdown-item>
                  <el-dropdown-item v-if="s.psid!==0&&isadmin" @click.native="editStage(null,s)"><i class="el-icon-plus"></i> 在此后添加新阶段</el-dropdown-item>
                  <el-dropdown-item v-if="s.psid!==0&&s.psid!==-1&&isadmin" @click.native="delStage(s)"><i class="el-icon-delete"></i> 删除此阶段</el-dropdown-item>
                  <el-dropdown-item @click.native="exportStageTask(s)"><i class="el-icon-download"></i> 导出本列表所有事项</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="task-card" @dragenter="dragEnter($event,s)" @drop="dragDrop($event)" @dragover="dragOver($event)">
              <div class="drag-area" v-show="dragStageid===s.psid">松开移入此处</div>
              <div class="task-list" :key="taskBoxKey">
                <div v-for="t in tasklist" @click="viewTask(t)" :draggable="t.isopen===0?false:isadmin?true:t.userid===user.dUserid?true:false" @dragstart="dragStart($event, t)" @dragend="dragEnd($event)" class="task-item" v-if="t.psid===s.psid&&(showUnopened||(!showUnopened&&t.isopen===1))" :key="t.ptid">
                  <div class="task-content-box">
                    <div :class="t.psid===0?'not-open is-finsh':'not-open'" v-if="t.isopen===0||t.psid===0"></div>
                    <div class="task-priority" :style="`background: #${t.priority===1?'409EFF':t.priority===2?'E6A23C':t.priority===3?'F56C6C':'909399'}`"></div>
                    <div class="task-header">
                      <span class="task-text"><i class="el-icon-success" v-if="t.psid===0" style="color: #67C23A"></i> {{t.taskname}}</span>
                      <el-tooltip effect="dark" :content="t.userid!==0?t.username:'待认领'" placement="top" style="margin: 2px 0 0 12px;">
                        <el-avatar :size="24" :src="t.userid!==0?t.userphoto:user_photo"></el-avatar>
                      </el-tooltip>
                    </div>
                    <div class="task-tags" v-if="t.taglist.length>0">
                      <span v-for="tag in t.taglist" :class="`tag tag-${tag.color}`">{{tag.tag}}</span>
                    </div>
                    <div class="task-date" v-if="(t.startdate!==null&&t.startdate!==undefined&&t.startdate!=='')||(t.enddate!==null&&t.enddate!==undefined&&t.enddate!=='')"><i class="el-icon-time"></i> 计划：{{t.startdate!==null&&t.startdate!==undefined&&t.startdate!==''?dateToWz(t.startdate):'未设置'}}-{{t.enddate!==null&&t.enddate!==undefined&&t.enddate!==''?dateToWz(t.enddate):'未设置'}}</div>
                    <div class="task-date" v-if="(t.startdateReal!==null&&t.startdateReal!==undefined&&t.startdateReal!=='')||(t.enddateReal!==null&&t.enddateReal!==undefined&&t.enddateReal!=='')"><i class="el-icon-document-checked"></i> 实际：<span :class="t.isouttime===1?'time-out':''">{{t.startdateReal!==null&&t.startdateReal!==undefined&&t.startdateReal!==''?dateToWz(t.startdateReal):'未设置'}}-{{t.enddateReal!==null&&t.enddateReal!==undefined&&t.enddateReal!==''?dateToWz(t.enddateReal):'未设置'}}</span></div>
                    <div class="task-percent" v-if="t.psid!==0&&t.percent>0"><el-progress :percentage="t.percent" :show-text="false"></el-progress></div>
                  </div>
                </div>
              </div>
              <div class="task-add" v-if="isadmin">
                <div class="task-add-btn" @click="addTask(s.psid)"><i class="el-icon-plus"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dynamic-box" v-show="tabName==='tab2'">
      <el-row class="tcf-row">
        <el-col  class="card">
          <div class="card-body">
            <div class="card-title">
              <div class="search-mode">
                <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                  <el-form-item label="发布日期">
                    <el-date-picker
                      v-model="searchForm.time"
                      size="mini"
                      format="yyyy年MM月dd日"
                      value-format="yyyy-MM-dd"
                      start-placeholder="设置开始日期"
                      end-placeholder="设置截止日期"
                      clearable
                      type="daterange">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="事项">
                    <el-select v-model="searchForm.ptid" filterable clearable>
                      <el-option v-for="t in tasklist" :label="t.taskname" :value="t.ptid"/>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="搜索关键字">
                    <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="SearchDynamic"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" @click="SearchDynamic">搜索</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="card-content task-dynamic-box2">
                <div class="dynamic-tab">
                  <div :class="dynamicTab===0?'tab checked':'tab'" @click="setDynamicTab(0)">所有动态</div>
                  <div :class="dynamicTab===1?'tab checked':'tab'" @click="setDynamicTab(1)">仅评论</div>
                  <div :class="dynamicTab===2?'tab checked':'tab'" @click="setDynamicTab(2)">仅附件</div>
                  <div style="padding-left: 10px" v-if="dynamicList.length>0">共 {{dynamicList.length}} 条动态</div>
                </div>
                <div class="dynamic-list-box" v-loading="dynamicLoading">
                  <div class="dynamic-list">
                    <div class="not-dynamic" v-if="dynamicList.length<=0">
                      <div class="icon"><i class="el-icon-document-copy"></i></div>
                      <span>暂无该类型动态</span>
                    </div>
                    <div class="dynamic-item" v-for="d in dynamicList">
                      <el-avatar class="photo" :size="40" :src="d.userphoto"></el-avatar>
                      <div class="dynamic-info">
                        <div class="tit">
                          <div class="txt"><span>{{d.username}}</span>{{d.title}}</div>
                          <div class="time">{{d.time}}</div>
                        </div>
                        <div class="content" v-if="d.content!==null&&d.content.trim()!==''&&d.content!==undefined">{{d.content}}</div>
                        <div class="file-list" v-if="d.filelst.length>0">
                          <div class="file-item" v-for="f in d.filelst" @click="downFile(f.fileid)">
                            <el-image :src="f.img" fit="cover" class="icon"></el-image>
                            <div class="name">{{`${f.filename}.${f.filetype}`}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dynamic-box" v-show="tabName==='tab3'">
      <el-row class="tcf-row">
        <el-col class="card">
          <div class="card-body">
            <div class="card-title">
              <div class="file-header">
                <el-breadcrumb class="file-breadcrumb" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(f,index) in fileSxData" @click.native="setFileSx(index)">{{f.name}}</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="file-header-right">
                  <el-popover
                    placement="bottom-end"
                    width="260"
                    v-model="addFolderVisible">
                    <el-input v-model="foldername" size="small" style="margin-bottom: 10px" placeholder="请输入文件夹名称" maxlength="100"></el-input>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="addFolderVisible = false">取消</el-button>
                      <el-button type="primary" size="mini" :loading="editLoading" @click="subAddFolder">确定</el-button>
                    </div>
                    <el-button type="text" slot="reference" icon="el-icon-circle-plus">创建文件夹</el-button>
                  </el-popover>
                  <el-upload
                    ref="multiUploadFile2"
                    :action="uploadFile"
                    :on-success="successAddProjectFile"
                    :on-error="errorMultiFile"
                    multiple
                    :limit="99">
                    <el-button type="text" style="margin-left: 20px" icon="el-icon-upload">上传文件</el-button>
                  </el-upload>
                </div>
              </div>
              <div class="card-content" v-loading="fileLoading">
                <el-table
                  :data="fileData"
                  style="width: 100%"
                  :row-style="{cursor: 'pointer'}"
                  empty-text="文件夹中还没有内容哦"
                  @row-click="openFileDetails">
                  <el-table-column
                    prop="date"
                    label="名称"
                    min-width="180">
                    <template slot-scope="scope">
                      <div style="display: flex;justify-items: center;align-items: center">
                        <el-image style="width: 30px; height: 30px" :src="scope.row.img" fit="cover"></el-image>
                        <div style="font-size: 14px;color: #262626;margin-left: 12px">{{scope.row.type===1?`${scope.row.filename}.${scope.row.filetype}`:scope.row.name}}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="大小"
                    width="120">
                    <template slot-scope="scope">{{scope.row.type===1?`${scope.row.filesize}MB`:'-'}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    width="120"
                    label="创建者">
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    width="160"
                    label="上传时间">
                  </el-table-column>
                  <el-table-column
                    width="160"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" v-if="scope.row.type===0" :disabled="!isadmin&&scope.row.userid!==user.dUserid" @click.stop="renameFile(scope.row)" icon="el-icon-edit">重命名</el-button>
                      <el-button type="text" size="mini" v-if="scope.row.type===1" @click.stop="downFile(scope.row.fileid)" icon="el-icon-download">下载</el-button>
                      <el-button type="text" size="mini" :disabled="!isadmin&&scope.row.userid!==user.dUserid" @click.stop="delProjectFile(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dynamic-box" v-show="tabName==='tab4'">
      <el-row class="tcf-row">
        <el-col  class="card">
          <div class="card-body">
            <div class="card-title">
              <div class="card-content project-info" v-loading="overviewLoading">
                <el-row>
                  <el-col :span="16">
                    <div class="overview-box">
                      <div :class="overviewChange===0?'overview-item active':'overview-item'" @click="setOverviewChange(0)">
                        <span>总数</span>
                        <div class="num">{{overviewNum.zs}}</div>
                        <el-progress :percentage="100" color="#3DA8F5" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===1?'overview-item active':'overview-item'" @click="setOverviewChange(1)">
                        <span>已完成</span>
                        <div class="num">{{overviewNum.ywc}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.ywc/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===2?'overview-item active':'overview-item'" @click="setOverviewChange(2)">
                        <span>未完成</span>
                        <div class="num">{{overviewNum.wwc}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.wwc/overviewNum.zs*100:0" color="#FF8479" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===3?'overview-item active':'overview-item'" @click="setOverviewChange(3)">
                        <span>已逾期</span>
                        <div class="num">{{overviewNum.yyq}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.yyq/overviewNum.zs*100:0" color="#FF9F00" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===4?'overview-item active':'overview-item'" @click="setOverviewChange(4)">
                        <span>待认领</span>
                        <div class="num">{{overviewNum.drl}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.drl/overviewNum.zs*100:0" color="#A1A4D9" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===5?'overview-item active':'overview-item'" @click="setOverviewChange(5)">
                        <span>时间待定</span>
                        <div class="num">{{overviewNum.sjdd}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.sjdd/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===6?'overview-item active':'overview-item'" @click="setOverviewChange(6)">
                        <span>今日到期</span>
                        <div class="num">{{overviewNum.jrdq}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.jrdq/overviewNum.zs*100:0" color="#FFC774" :show-text="false"></el-progress>
                      </div>
                      <div :class="overviewChange===7?'overview-item active':'overview-item'" @click="setOverviewChange(7)">
                        <span>逾期完成</span>
                        <div class="num">{{overviewNum.yqwc}}</div>
                        <el-progress :percentage="overviewNum.zs>0?overviewNum.yqwc/overviewNum.zs*100:0" color="#FF8478" :show-text="false"></el-progress>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-box">
                      <el-progress type="circle" class="percent" :width="70" :percentage="projectPercent"></el-progress>
                      <div class="name">{{project.name}}</div>
                      <div class="time">{{project.username}}于 {{dateToWz(project.time)}} 创建</div>
                    </div>
                    <div class="info">
                      <div class="tit"><i class="el-icon-document"></i><span>项目说明</span></div>
                      <div class="txt">{{project.explain!==null&&project.explain!==''&&project.explain!==undefined?project.explain:'未填写'}}</div>
                    </div>
                    <div class="info">
                      <div class="tit"><i class="el-icon-date"></i><span>项目周期</span></div>
                      <div class="txt">{{dateToWz(project.startdate)}} - {{dateToWz(project.enddate)}}</div>
                    </div>
                    <div class="info">
                      <div class="tit"><i class="el-icon-finished"></i><span>项目状态</span></div>
                      <div class="txt">
                        <el-tag v-if="project.mark===0" type="danger" :disable-transitions="true" size="mini">未开始</el-tag>
                        <el-tag v-if="project.mark===1" type="success" :disable-transitions="true" size="mini">进行中</el-tag>
                        <el-tag v-if="project.mark===2" type="warning" :disable-transitions="true" size="mini">已暂停</el-tag>
                        <el-tag v-if="project.mark===3" :disable-transitions="true" size="mini">已完成</el-tag>
                        <el-tag v-if="project.mark===4" type="info" :disable-transitions="true" size="mini">已取消</el-tag>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" style="padding-top: 20px">
                    <el-table
                      :data="overviewData"
                      border
                      :row-style="{cursor: 'pointer'}"
                      @row-click="viewTask"
                      style="width: 100%">
                      <el-table-column
                        type="index"
                        align="center"
                        width="50">
                      </el-table-column>
                      <el-table-column
                        label="计划周期"
                        width="220">
                        <template slot-scope="scope">
                          <span v-if="scope.row.startdate!==null&&scope.row.startdate!==undefined&&scope.row.startdate!==''&&scope.row.enddate!==null&&scope.row.enddate!==undefined&&scope.row.enddate!==''">{{dateToWz(scope.row.startdate)}}-{{dateToWz(scope.row.enddate)}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="taskname"
                        label="事项"
                        width="200">
                      </el-table-column>
                      <el-table-column
                        prop="username"
                        label="执行人"
                        width="100">
                      </el-table-column>
                      <el-table-column
                        label="当前阶段"
                        width="160">
                        <template slot-scope="scope">
                          <span v-for="s in stagelist" v-if="scope.row.psid===s.psid">{{s.stagename}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="当前进度"
                        width="100">
                        <template slot-scope="scope">
                          {{scope.row.psid===0?100:scope.row.percent}}%
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优先级"
                        width="120">
                        <template slot-scope="scope">
                          <el-tag :type="scope.row.priority===1?'':scope.row.priority===2?'warning':scope.row.priority===3?'danger':'info'" size="small" effect="plain">{{scope.row.priority===1?'普通':scope.row.priority===2?'紧急':scope.row.priority===3?'非常紧急':'较低'}}</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="stagename"
                        label="实际工期"
                        min-width="220">
                        <template slot-scope="scope">
                          <span v-if="scope.row.startdateReal!==null&&scope.row.startdateReal!==undefined&&scope.row.startdateReal!==''&&scope.row.enddateReal!==null&&scope.row.enddateReal!==undefined&&scope.row.enddateReal!==''">{{dateToWz(scope.row.startdateReal)}}-{{dateToWz(scope.row.enddateReal)}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dynamic-box" v-show="tabName==='tab5'">
      <el-row class="tcf-row" v-loading="chartLoading">
        <el-col class="card" :span="12" style="padding-right: 10px">
          <div class="card-body">
            <div class="card-title">
              事项按执行人分布
              <div class="card-content">
                <div id="taskUserChart" style="height: 300px;"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col class="card" :span="12" style="padding-left: 10px;">
          <div class="card-body">
            <div class="card-title">
              事项按执行人对比
              <div class="card-content">
                <div id="taskChart" style="height: 300px;"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col class="card" :span="12" style="padding-right: 10px;margin-top: 20px">
          <div class="card-body">
            <div class="card-title">
              事项燃尽图
              <div class="card-content">
                <div id="taskBurnOutChart" style="height: 300px;"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col class="card" :span="12" style="padding-left: 10px;margin-top: 20px">
          <div class="card-body">
            <div class="card-title">
              项目进展走势图
              <div class="card-content">
                <div id="projectProgressTrendChart" style="height: 300px;"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dynamic-box" v-show="tabName==='tab6'">
      <el-row class="tcf-row">
        <el-col  class="card">
          <div class="card-body">
            <div class="card-title">
              <div class="card-content" v-loading="gtLoading" style="min-height: 100px;">
                <gantt-elastic v-if="gtShow" :tasks="gttasks" :options="gtoptions"></gantt-elastic>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="项目成员"
      :visible.sync="teamVisible"
      width="400px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <div class="team-add-box">
        <el-cascader
          v-if="isadmin"
          style="width: 100%"
          v-model="changeTeamUser"
          :options="deptEmployeeTree"
          :props="{multiple: true}"
          placeholder="搜索成员"
          :show-all-levels="false"
          size="mini"
          filterable
          clearable></el-cascader>
        <el-button v-if="isadmin" style="margin-left: 10px" size="small" @click="addTeam" :loading="addTeamLoading" type="primary" icon="el-icon-plus">添加</el-button>
      </div>
      <div class="team-user-list">
        <div class="team-user-item">
          <el-avatar size="medium" :src="project.userphoto"></el-avatar>
          <span class="name">{{project.username}}</span>
          <el-tag size="small" type="warning" effect="plain">创建者</el-tag>
        </div>
        <div class="team-user-item" v-for="u in project.teamlist">
          <el-avatar size="medium" :src="u.photo"></el-avatar>
          <span class="name">{{u.name}}</span>
          <el-tag size="small" :type="u.role===1?'':'info'" effect="plain">{{u.role===1?'项目管理员':'项目成员'}}</el-tag>
          <div class="btn" v-if="isadmin&&u.userid!==user.dUserid">
            <span class="d" @click="editTeam(u)">权限<i class="el-icon-refresh"></i></span>
            <span class="d" @click="delTeam(u)">移除</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="项目设置"
      :visible.sync="projectInfoVisible"
      width="700px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-alert
        v-if="!isadmin"
        title="您暂时没有权限修改该处设置。请联系创建者或管理员操作。"
        type="warning"
        :closable="false"
        style="margin-bottom: 20px"
        show-icon>
      </el-alert>
      <div style="width: 100%;position: relative;padding-left: 116px">
        <el-tabs v-model="setActiveName" tab-position="left" style="position: absolute;left: 0;top: 0">
          <el-tab-pane label="项目信息" name="xmxx"></el-tab-pane>
          <el-tab-pane label="事项指派" name="plzp"></el-tab-pane>
          <el-tab-pane label="事项排期" name="pljh"></el-tab-pane>
        </el-tabs>
        <el-form v-if="setActiveName==='xmxx'" ref="eForm" :model="eForm"  :rules="eFormRules" label-position="right" label-width="80px" size="small">
          <el-form-item label="项目名称" prop="name">
            <el-input v-model="eForm.name" :disabled="!isadmin" clearable maxlength="100" style="width: 100%" show-word-limit />
          </el-form-item>
          <el-form-item label="项目说明" prop="explain">
            <el-input
              style="width: 100%"
              v-model="eForm.explain"
              maxlength="300"
              type="textarea"
              :rows="2"
              :disabled="!isadmin"
              clearable
              show-word-limit/>
          </el-form-item>
          <el-form-item label="项目状态" prop="mark">
            <el-radio-group v-model="eForm.mark" :disabled="!isadmin">
              <el-radio :label="0">未开始</el-radio>
              <el-radio :label="1">进行中</el-radio>
              <el-radio :label="2">已暂停</el-radio>
              <el-radio :label="3">已完成</el-radio>
              <el-radio :label="4">已取消</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="项目周期" prop="time">
            <el-date-picker
              v-model="eForm.time"
              size="mini"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              :disabled="!isadmin"
              start-placeholder="开始日期"
              end-placeholder="截止日期"
              :clearable="false"
              type="daterange">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div v-if="setActiveName==='xmxx'" style="text-align: right">
          <el-button type="primary" v-if="isadmin" size="small" :loading="editLoading" @click="subEditInfo">提交</el-button>
          <el-button size="small" @click="projectInfoVisible = false">取消</el-button>
        </div>
        <div v-if="setActiveName==='plzp'" style="min-height: 200px;">
          <div class="task-set-user-box" v-for="pt in tasklist">
            <el-dropdown trigger="click" size="small" :key="`${pt.ptid}${new Date().getTime()}`" placement="bottom-start">
              <div class="user-select">
                <el-avatar :size="24" :src="pt.userid!==0?pt.userphoto:user_photo"></el-avatar>
                <span class="name">{{pt.userid!==0?pt.username:'待认领'}}</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="setTaskUserZP(pt,{userid: 0, name: '待认领', photo: user_photo})" :disabled="pt.userid===0||!isadmin">
                  <div style="display: flex;justify-items: center;align-items: center;padding: 8px 0">
                    <el-avatar :size="18" :src="user_photo"></el-avatar>
                    <span style="margin-left: 6px">待认领</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="setTaskUserZP(pt,{userid: project.userid, name: project.username, photo: project.userphoto})" :disabled="pt.userid===project.userid||!isadmin">
                  <div style="display: flex;justify-items: center;align-items: center;padding: 8px 0">
                    <el-avatar :size="18" :src="project.userphoto"></el-avatar>
                    <span style="margin-left: 6px">{{project.username}}</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-for="u in project.teamlist" @click.native="setTaskUserZP(pt,{userid: u.userid, name: u.name, photo: u.photo})" :disabled="pt.userid===u.userid||!isadmin">
                  <div style="display: flex;justify-items: center;align-items: center;padding: 8px 0">
                    <el-avatar :size="18" :src="u.photo"></el-avatar>
                    <span style="margin-left: 6px">{{u.name}}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-divider direction="vertical"></el-divider>
            <span class="task-name">{{pt.taskname}}</span>
          </div>
        </div>
        <div v-if="setActiveName==='pljh'" style="min-height: 200px;">
          <div class="task-set-time-box" v-for="pt in tasklist">
            <el-date-picker
              :key="`${pt.ptid}${new Date().getTime()}`"
              v-model="pt.jhtime"
              size="mini"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              :disabled="!isadmin"
              start-placeholder="设置开始日期"
              end-placeholder="设置截止日期"
              @input="subTaskTimeJH(pt)"
              type="daterange">
            </el-date-picker>
            <el-divider direction="vertical"></el-divider>
            <span class="task-name">{{pt.taskname}}</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="editStageTitle"
      :visible.sync="editStageVisible"
      width="300px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-input v-model="stageForm.name" maxlength="20" size="small" show-word-limit />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="editLoading" @click="subEditStage">提交</el-button>
        <el-button size="small" @click="editStageVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title=" "
      :visible.sync="taskVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-row style="padding: 0 30px">
        <el-col :span="16" class="task-info-box">
          <span class="task-name" v-if="taskDetail.userid!==user.dUserid&&!isadmin">{{taskDetail.taskname}}</span>
          <el-popover
            width="300"
            v-if="taskDetail.userid===user.dUserid||isadmin"
            :key="taskForm.namekey"
            v-model="taskForm.nameVisible"
            placement="bottom-start">
            <el-input placeholder="请输入事项名称" size="small" maxlength="100" show-word-limit v-model="taskForm.taskname">
            </el-input>
            <div style="text-align: right; margin: 8px 0 0 0">
              <el-button size="mini" type="text" @click="taskForm.nameVisible = false">取消</el-button>
              <el-button type="primary" size="mini" :loading="edittaskloading" @click="subTaskName">保存</el-button>
            </div>
            <el-tooltip effect="dark" content="点击即可编辑" placement="top" slot="reference">
              <span class="task-name">{{taskDetail.taskname}}</span>
            </el-tooltip>
          </el-popover>
          <div class="task-form" style="margin-top: 24px">
            <div class="tit"><i class="el-icon-finished"></i> 阶段</div>
            <div class="val">
              <el-dropdown trigger="click" :key="new Date().getTime()" placement="bottom-start">
                <span :class="taskDetail.psid===0?'stage-select stage-success':'stage-select'">{{ taskDetail.psid===0?'已完成':taskDetail.psid===-1?'未开始':taskForm.stagename }} <i class="el-icon-caret-bottom"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="s in stagelist" @click.native="editTaskStage({ptid:taskDetail.ptid,psid:s.psid},taskDetail.psid)" :disabled="taskDetail.psid===s.psid||(!isadmin&&taskDetail.userid!==user.dUserid)">
                    <div style="width: 200px;display: flex;justify-items: center;align-items: center;justify-content: space-between;padding: 6px 0">
                      <el-tag size="small" :type="s.psid===0?'success':'info'">{{s.stagename}}</el-tag>
                      <i class="el-icon-check" v-if="taskDetail.psid===s.psid"></i>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-news"></i> 进度（%）</div>
            <div class="val">
              <div style="width: 300px">
                <el-slider v-if="taskDetail.psid!==0&&(isadmin||taskDetail.userid===user.dUserid)" v-model="taskDetail.percent" :show-input="true" input-size="mini" @change="changePercent" :min="0" :max="100"></el-slider>
                <el-slider v-if="taskDetail.psid===0" v-model="defPercent" :show-input="true" input-size="mini" disabled :min="0" :max="100"></el-slider>
                <el-slider v-if="taskDetail.psid!==0&&(!isadmin&&taskDetail.userid!==user.dUserid)" v-model="taskDetail.percent" :show-input="true" input-size="mini" disabled :min="0" :max="100"></el-slider>
              </div>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-user"></i> 执行人</div>
            <div class="val">
              <el-button v-if="!isadmin&&taskDetail.userid===0" type="text" @click="setTaskUser(user.dUserid)">立即认领</el-button>
              <el-dropdown v-if="isadmin||taskDetail.userid!==0" trigger="click" size="small" :key="new Date().getTime()+1" placement="bottom-start">
                <div class="user-select">
                  <el-avatar :size="24" :src="taskDetail.userid!==0?taskDetail.userphoto:user_photo"></el-avatar>
                  <span class="name">{{taskDetail.userid!==0?taskDetail.username:'待认领'}}</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="setTaskUser(0)" :disabled="taskDetail.userid===0||(taskDetail.userid!==0&&!isadmin&&taskDetail.userid!==user.dUserid)">
                    <div style="display: flex;justify-items: center;align-items: center;padding: 8px 0">
                      <el-avatar :size="18" :src="user_photo"></el-avatar>
                      <span style="margin-left: 6px">待认领</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="isadmin" @click.native="setTaskUser(project.userid)" :disabled="taskDetail.userid===project.userid||(taskDetail.userid!==0&&!isadmin&&taskDetail.userid!==user.dUserid)">
                    <div style="display: flex;justify-items: center;align-items: center;padding: 8px 0">
                      <el-avatar :size="18" :src="project.userphoto"></el-avatar>
                      <span style="margin-left: 6px">{{project.username}}</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="isadmin" v-for="u in project.teamlist" @click.native="setTaskUser(u.userid)" :disabled="taskDetail.userid===u.userid||(taskDetail.userid!==0&&!isadmin&&taskDetail.userid!==user.dUserid)">
                    <div style="display: flex;justify-items: center;align-items: center;padding: 8px 0">
                      <el-avatar :size="18" :src="u.photo"></el-avatar>
                      <span style="margin-left: 6px">{{u.name}}</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-date"></i> 计划周期</div>
            <div class="val">
              <el-date-picker
                v-model="taskForm.time"
                size="mini"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                :disabled="!isadmin&&taskDetail.userid!==user.dUserid"
                start-placeholder="设置开始日期"
                end-placeholder="设置截止日期"
                @change="subTaskTime"
                :clearable="false"
                type="daterange">
              </el-date-picker>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-document"></i> 说明</div>
            <div class="val">
              <span v-if="taskDetail.userid!==user.dUserid&&!isadmin" class="task-reamrk">{{taskDetail.remark!==null&&taskDetail.remark!==undefined&&taskDetail.remark!==''?taskDetail.remark:'待添加'}}</span>
              <el-popover
                width="300"
                v-if="taskDetail.userid===user.dUserid||isadmin"
                :key="taskForm.remarkkey"
                v-model="taskForm.reamrkVisible"
                placement="bottom-start">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入内容"
                  maxlength="300"
                  show-word-limit
                  v-model="taskForm.remark">
                </el-input>
                <div style="text-align: right; margin: 8px 0 0 0">
                  <el-button size="mini" type="text" @click="taskForm.reamrkVisible = false">取消</el-button>
                  <el-button type="primary" size="mini" :loading="edittaskloading" @click="subTaskRemark">保存</el-button>
                </div>
                <el-tooltip effect="dark" content="点击即可编辑" placement="top" slot="reference">
                  <span class="task-reamrk">{{taskDetail.remark!==null&&taskDetail.remark!==undefined&&taskDetail.remark!==''?taskDetail.remark:'待添加'}}</span>
                </el-tooltip>
              </el-popover>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-collection-tag"></i> 优先级</div>
            <div class="val">
              <el-dropdown trigger="click" :key="new Date().getTime()+2" placement="bottom-start">
                <el-tag :type="taskDetail.priority===1?'':taskDetail.priority===2?'warning':taskDetail.priority===3?'danger':'info'" size="small" effect="plain" style="font-size: 14px;cursor: pointer">{{taskDetail.priority===1?'普通':taskDetail.priority===2?'紧急':taskDetail.priority===3?'非常紧急':'较低'}}</el-tag>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="subTaskPriority(0)" :disabled="taskDetail.priority===0||(taskDetail.userid!==user.dUserid&&!isadmin)">
                    <el-tag type="info" size="small" effect="plain">较低</el-tag>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="subTaskPriority(1)" :disabled="taskDetail.priority===1||(taskDetail.userid!==user.dUserid&&!isadmin)">
                    <el-tag size="small" effect="plain">普通</el-tag>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="subTaskPriority(2)" :disabled="taskDetail.priority===2||(taskDetail.userid!==user.dUserid&&!isadmin)">
                    <el-tag type="warning" size="small" effect="plain">紧急</el-tag>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="subTaskPriority(3)" :disabled="taskDetail.priority===3||(taskDetail.userid!==user.dUserid&&!isadmin)">
                    <el-tag type="danger" size="small" effect="plain">非常紧急</el-tag>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-price-tag"></i> 标签</div>
            <div class="val">
              <span v-if="taskDetail.userid!==user.dUserid&&!isadmin&&taskDetail.taglist!==undefined&&taskDetail.taglist!==null&&taskDetail.taglist.length<=0" class="task-reamrk">未添加</span>
              <el-tag v-for="t in taskDetail.taglist" :type="t.color==='green'?'success':t.color==='red'?'danger':t.color==='gray'?'info':t.color==='yellow'?'warning':''" style="margin-right: 10px" :disable-transitions="true" size="small" @close="delTaskTag(t)" :closable="taskDetail.userid===user.dUserid||isadmin">{{t.tag}}</el-tag>
              <el-popover
                :key="taskForm.tagkey"
                width="200"
                v-if="taskDetail.userid===user.dUserid||isadmin"
                v-model="taskForm.tagVisible"
                placement="bottom-start">
                <el-input v-model="taskForm.tagname" size="small" maxlength="100" placeholder="标签名称" show-word-limit></el-input>
                <div style="width: 100%;display: flex;justify-items: center;align-items: center;margin: 20px 0;justify-content: space-between">
                  <div @click="taskForm.tagcolor='blue'" style="width: 24px;height: 24px;border-radius: 12px;text-align: center;line-height: 24px;background:#409EFF;cursor: pointer">
                    <i class="el-icon-check" v-if="taskForm.tagcolor==='blue'" style="color: #fff;font-weight: bold"></i>
                  </div>
                  <div @click="taskForm.tagcolor='green'" style="width: 24px;height: 24px;border-radius: 12px;text-align: center;line-height: 24px;background:#67C23A;cursor: pointer">
                    <i class="el-icon-check" v-if="taskForm.tagcolor==='green'" style="color: #fff;font-weight: bold"></i>
                  </div>
                  <div @click="taskForm.tagcolor='yellow'" style="width: 24px;height: 24px;border-radius: 12px;text-align: center;line-height: 24px;background:#E6A23C;cursor: pointer">
                    <i class="el-icon-check" v-if="taskForm.tagcolor==='yellow'" style="color: #fff;font-weight: bold"></i>
                  </div>
                  <div @click="taskForm.tagcolor='red'" style="width: 24px;height: 24px;border-radius: 12px;text-align: center;line-height: 24px;background:#F56C6C;cursor: pointer">
                    <i class="el-icon-check" v-if="taskForm.tagcolor==='red'" style="color: #fff;font-weight: bold"></i>
                  </div>
                  <div @click="taskForm.tagcolor='gray'" style="width: 24px;height: 24px;border-radius: 12px;text-align: center;line-height: 24px;background:#909399;cursor: pointer">
                    <i class="el-icon-check" v-if="taskForm.tagcolor==='gray'" style="color: #fff;font-weight: bold"></i>
                  </div>
                </div>
                <el-button type="primary" style="width: 100%;" size="small" :loading="edittaskloading" @click="subTaskTag">创建标签</el-button>
                <i class="el-icon-circle-plus task-tag-add" slot="reference"></i>
              </el-popover>
            </div>
          </div>
          <div class="task-form">
            <div class="tit"><i class="el-icon-timer"></i> 实际工期</div>
            <div class="val">
              <el-date-picker
                v-model="taskForm.realtime"
                size="mini"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                :disabled="!isadmin&&taskDetail.userid!==user.dUserid"
                start-placeholder="设置开始日期"
                end-placeholder="设置截止日期"
                @change="subTaskRealTime"
                :clearable="false"
                type="daterange">
              </el-date-picker>
            </div>
          </div>
          <div class="task-form" v-if="isadmin">
            <div class="tit"><i class="el-icon-delete"></i> 删除事项</div>
            <div class="val">
              <el-popconfirm title="确定删除此事项吗？" :key="new Date().getTime()+5" @onConfirm="delTask">
                <el-button size="small" type="danger" :loading="edittaskloading" slot="reference">删除此事项</el-button>
              </el-popconfirm>

            </div>
          </div>
        </el-col>
        <el-col :span="8" class="task-dynamic-box">
          <div class="dynamic-tab">
            <div :class="dynamicTab===0?'tab checked':'tab'" @click="setDynamicTab(0)">所有动态</div>
            <div :class="dynamicTab===1?'tab checked':'tab'" @click="setDynamicTab(1)">仅评论</div>
            <div :class="dynamicTab===2?'tab checked':'tab'" @click="setDynamicTab(2)">仅附件</div>
          </div>
          <div class="dynamic-list-box" v-loading="dynamicLoading">
            <div class="dynamic-list">
              <div class="not-dynamic" v-if="dynamicList.length<=0">
                <div class="icon"><i class="el-icon-document-copy"></i></div>
                <span>暂无该类型动态</span>
              </div>
              <div class="dynamic-item" v-for="d in dynamicList">
                <el-avatar class="photo" :size="24" :src="d.userphoto"></el-avatar>
                <div class="right">
                  <div class="tit">
                    <div class="txt"><span>{{d.username}}</span>{{d.title}}</div>
                    <div class="time">{{d.time}}</div>
                  </div>
                  <div class="content" v-if="d.content!==null&&d.content.trim()!==''&&d.content!==undefined">{{d.content}}</div>
                  <div class="file-list" v-if="d.filelst.length>0">
                    <div class="file-item" v-for="f in d.filelst" @click="downFile(f.fileid)">
                      <el-image :src="f.img" fit="cover" class="icon"></el-image>
                      <el-tooltip  effect="dark" :content="`${f.filename}.${f.filetype}`" placement="top">
                        <div class="name">{{`${f.filename}.${f.filetype}`}}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="task-dynamic-input-box">
            <el-input v-if="enterType===0" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="输入评论内容，按 Enter 快速发布" resize="none" v-model="dynamicContent" @keyup.enter.native="subTaskDynamic(taskDetail.ptid)"  maxlength="300"></el-input>
            <el-input v-if="enterType===1" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="输入评论内容，按 Ctrl+Enter 快速发布" resize="none" v-model="dynamicContent" @keyup.ctrl.enter.native="subTaskDynamic(taskDetail.ptid)"  maxlength="300"></el-input>
            <div class="btn-box">
              <el-upload
                ref="multiUploadFile"
                :action="uploadFile"
                :on-remove="handleFileRemove"
                :before-remove="beforeFileRemove"
                :on-success="successMultiFile"
                :on-error="errorMultiFile"
                multiple
                :limit="9"
                :on-exceed="handleFileExceed">
                <div class="up">
                  <el-tooltip  effect="dark" content="点击上传附件" placement="top">
                    <i class="el-icon-paperclip"></i>
                  </el-tooltip>
                </div>
              </el-upload>
              <div class="btn">
                <el-button type="text" :loading="editLoading" @click="subTaskDynamic(taskDetail.ptid)">发布</el-button>
                <el-dropdown trigger="click" :key="new Date().getTime()+10">
                  <div class="more"><i class="el-icon-caret-bottom"></i></div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="enterType=0">
                      <div style="display: flex;justify-items: center;align-items: center;justify-content: space-between">
                        <div style="width: 180px">按 Enter 发布评论</div>
                        <i v-if="enterType===0" class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="enterType=1">
                      <div style="display: flex;justify-items: center;align-items: center;justify-content: space-between">
                        <div style="width: 180px">按 Ctrl+Enter 发布评论</div>
                        <i v-if="enterType===1" class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="添加事项"
      :visible.sync="addTaskVisible"
      width="400px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-form ref="addTaskForm" :model="addTaskForm"  :rules="addTaskFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="事项名称" prop="taskname">
          <el-input v-model="addTaskForm.taskname" clearable maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item label="事项说明" prop="remark">
          <el-input
            v-model="addTaskForm.remark"
            maxlength="300"
            type="textarea"
            :rows="2"
            clearable
            show-word-limit/>
        </el-form-item>
        <el-form-item label="执行人" prop="userid">
          <el-select v-model="addTaskForm.userid" placeholder="请选择">
            <el-option label="待认领" :value="0">
              <div style="display: flex;justify-items: center;align-items: center;">
                <el-avatar :size="18" :src="user_photo"></el-avatar>
                <span style="margin-left: 6px">待认领</span>
              </div>
            </el-option>
            <el-option :label="project.username" :value="project.userid">
              <div style="display: flex;justify-items: center;align-items: center;">
                <el-avatar :size="18" :src="project.userphoto"></el-avatar>
                <span style="margin-left: 6px">{{project.username}}</span>
              </div>
            </el-option>
            <el-option v-for="u in project.teamlist" :label="u.name" :value="u.userid">
              <div style="display: flex;justify-items: center;align-items: center;">
                <el-avatar :size="18" :src="u.photo"></el-avatar>
                <span style="margin-left: 6px">{{u.name}}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优先级" prop="priority">
          <el-dropdown trigger="click" :key="new Date().getTime()+2" placement="bottom-start">
            <el-tag :type="addTaskForm.priority===1?'':addTaskForm.priority===2?'warning':addTaskForm.priority===3?'danger':'info'" size="small" effect="plain" style="font-size: 14px;cursor: pointer">{{addTaskForm.priority===1?'普通':addTaskForm.priority===2?'紧急':addTaskForm.priority===3?'非常紧急':'较低'}}</el-tag>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="addTaskForm.priority=0" :disabled="addTaskForm.priority===0">
                <el-tag type="info" size="small" effect="plain">较低</el-tag>
              </el-dropdown-item>
              <el-dropdown-item @click.native="addTaskForm.priority=1" :disabled="addTaskForm.priority===1">
                <el-tag size="small" effect="plain">普通</el-tag>
              </el-dropdown-item>
              <el-dropdown-item @click.native="addTaskForm.priority=2" :disabled="addTaskForm.priority===2">
                <el-tag type="warning" size="small" effect="plain">紧急</el-tag>
              </el-dropdown-item>
              <el-dropdown-item @click.native="addTaskForm.priority=3" :disabled="addTaskForm.priority===3">
                <el-tag type="danger" size="small" effect="plain">非常紧急</el-tag>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item label="计划周期" prop="time">
          <el-date-picker
            v-model="addTaskForm.time"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            start-placeholder="设置开始日期"
            end-placeholder="设置截止日期"
            clearable
            type="daterange">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" size="small" :loading="edittaskloading" @click="subAddTask">确定</el-button>
        <el-button size="small" @click="addTaskVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { editProjectTaskPercent, editProjectFile, selectByIdProject, projectTeamEdit, getDeptEmployeeTree, editProjectSetInfo, getProjectTaskListByPid, editProjectStage, exportProjectTaskExcel, editProjectTaskStage, editProjectTaskInfo, addOrDelProjectTaskTag, addProjectTask, delProjectTask, getProjectDynamicList, addProjectDynamic, getProjectFileList, addProjectFile } from '@/api/work'
import user_photo from '@/assets/user_photo.png'
import { formatDate, getFileInfo } from '@/api/pub'
import * as echarts from 'echarts'
import GanttElastic from 'gantt-elastic'
export default {
  name: 'ProjectHomepage',
  computed: {
    user: getUser
  },
  components: {
    ganttElastic: GanttElastic
  },
  data() {
    return {
      defPercent: 100,
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadFile',
      user_photo: user_photo,
      setActiveName: 'xmxx',
      loading: false,
      tabName: 'tab1',
      pid: null,
      project: {},
      projectTeamAllname: '',
      teamVisible: false,
      isadmin: false, // 是否是管理员或创建者
      changeTeamUser: [],
      deptEmployeeTree: [],
      addTeamLoading: false,
      projectInfoVisible: false,
      eForm: {
        pid: null,
        name: null,
        explain: null,
        time: [],
        mark: 0
      },
      eFormRules: {
        name: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        mark: [{ required: true, message: '项目状态不能为空', trigger: 'change' }],
        time: [{ required: true, message: '项目周期不能为空', trigger: 'change' }]
      },
      editLoading: false,
      showUnopened: false,
      search: '',
      stagelist: [],
      taskbaselist: [],
      tasklist: [],
      editStageTitle: '',
      editStageVisible: false,
      stageForm: {
        psid: null,
        xh: null,
        name: '',
        oldid: null
      },
      isTaskdrag: false,
      dragTask: null,
      dragStageid: null,
      taskVisible: false,
      taskDetail: {},
      edittaskloading: false,
      taskBoxKey: '',
      taskForm: {
        nameVisible: false,
        taskname: '',
        namekey: '',
        time: [],
        reamrkVisible: false,
        remark: '',
        tagVisible: false,
        tagname: '',
        tagcolor: 'blue',
        realtime: [],
        remarkkey: '',
        tagkey: '',
        stagename: ''
      },
      addTaskForm: {
        taskname: '',
        remark: '',
        userid: 0,
        priority: 0,
        psid: -1,
        time: []
      },
      addTaskFormRules: {
        taskname: [{ required: true, message: '事项名称不能为空', trigger: 'blur' }]
      },
      addTaskVisible: false,
      dynamicContent: '',
      dynamicTab: 0,
      dynamicBaseList: [],
      dynamicList: [],
      dynamicLoading: false,
      fileids: [],
      enterType: 0,
      searchForm: {
        search: '',
        ptid: '',
        time: []
      },
      fileSxData: [{ pfid: 0, name: '文件库' }],
      fileBaseData: [],
      fileData: [],
      fileLoading: false,
      addFolderVisible: false,
      foldername: '',
      overviewLoading: false,
      overviewNum: {
        zs: 0,
        ywc: 0,
        wwc: 0,
        yyq: 0,
        drl: 0,
        sjdd: 0,
        jrdq: 0,
        yqwc: 0
      },
      overviewChange: 0,
      overviewBaseData: [],
      overviewData: [],
      chartLoading: false,
      gttasks: [],
      gtoptions: {},
      gtShow: false,
      gtLoading: false,
      projectPercent: 0
    }
  },
  watch: {
    'tabName': function(val) {
      if (val === 'tab1') {
        this.getData()
      } else if (val === 'tab2') {
        this.SearchDynamic()
      } else if (val === 'tab3') {
        this.getFiles()
      } else if (val === 'tab4') {
        this.getOverviewData()
      } else if (val === 'tab5') {
        this.getChartData()
      } else if (val === 'tab6') {
        this.setGantElastic()
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.pid = this.$route.params && this.$route.params.id
    this.getData()
  },
  methods: {
    setGantElastic() {
      this.gtLoading = true
      getProjectTaskListByPid({ pid: this.project.pid }).then(response => {
        let _gttasks = []
        const that = this
        let xh = 1
        for (const t of response.data) {
          let stage = ''
          let _color = '#909399'
          if (t.psid === -1) {
            stage = '未开始'
          } else if (t.psid === 0) {
            stage = '已完成'
            _color = '#67C23A'
          } else {
            _color = '#E6A23C'
            for (const s of this.stagelist) {
              if (s.psid === t.psid) {
                stage = s.stagename
                break
              }
            }
          }
          _gttasks.push({
            id: xh,
            taskdata: t,
            label: t.taskname,
            user: t.userid !== 0 ? t.username : '',
            time: t.enddate !== null && t.enddate !== undefined && t.enddate !== '' ? `${this.dateToWz(t.startdate)}-${this.dateToWz(t.enddate)}` : '',
            start: t.enddate !== null && t.enddate !== undefined && t.enddate !== '' ? t.startdate : new Date().getTime(),
            end: t.enddate !== null && t.enddate !== undefined && t.enddate !== '' ? t.enddate : new Date().getTime(),
            mark: stage,
            type: t.enddate !== null && t.enddate !== undefined && t.enddate !== '' ? 'task' : '',
            duration: this.getDateBetween(t.startdate, t.enddate) * 24 * 60 * 60 * 1000,
            percent: t.psid === 0 ? 100 : t.percent,
            style: {
              base: {
                fill: _color,
                stroke: _color
              }
            }
          })
          xh++
        }
        this.gttasks = _gttasks
        this.gtoptions = {
          taskMapping: {
            progress: 'percent'
          },
          times: {
            timeZoom: 21
          },
          chart: {
            grid: {
              horizontal: {
                gap: 6
              }
            },
            text: {
              offset: 4,
              xPadding: 10,
              display: true
            },
            expander: {
              type: 'chart',
              display: true,
              displayIfTaskListHidden: true,
              offset: 4,
              size: 18
            }
          },
          taskList: {
            expander: {
              straight: false
            },
            columns: [
              {
                id: 1,
                label: '#',
                value: 'id',
                width: 40
              }, {
                id: 2,
                label: '事项名称',
                value: t => `<a href="javascript:void(0);" style="color:#409EFF">${t.label}</a>`,
                width: 120,
                expander: true,
                html: true,
                events: {
                  click({ data, column }) {
                    that.viewTask(data.taskdata)
                  }
                }
              }, {
                id: 3,
                label: '执行人',
                value: 'user',
                width: 70,
                html: true
              }, {
                id: 4,
                label: '计划周期',
                value: 'time',
                width: 200
              }, {
                id: 5,
                label: '当前阶段',
                value: 'mark',
                width: 80
              }, {
                id: 6,
                label: '进度',
                value: t => `${t.percent}%`,
                width: 60
              }
            ]
          },
          calendar: {
            workingDays: [1, 2, 3, 4, 5, 6],
            gap: 0,
            strokeWidth: 5,
            hour: {
              display: false
            }
          },
          scope: {
            after: 10
          },
          locale: {
            weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          }
        }
        this.gtShow = true
        this.gtLoading = false
      })
    },
    getDateBetween(date1, date2) {
      if (date1 === null || date1 === undefined || date1 === '' || date2 === null || date2 === undefined || date2 === '') {
        return 0
      }
      const startDate = Date.parse(date1)
      const endDate = Date.parse(date2)
      if (startDate > endDate) {
        return 0
      }
      if (startDate === endDate) {
        return 1
      }
      const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000)
      return days + 1
    },
    setProjectProgressTrendChart(taskdata) {
      let chart = echarts.getInstanceByDom(document.getElementById('projectProgressTrendChart'))
      if (chart == null) {
        chart = echarts.init(document.getElementById('projectProgressTrendChart'))
      }
      chart.clear()
      let xAxisData = []
      let dayarr = []
      for (let d = this.project.startdate; d !== this.addDay(this.project.enddate, 1); d = this.addDay(d, 1)) {
        xAxisData.push(d.substring(5, d.length))
        dayarr.push(d)
      }

      let zsData = []
      let wcData = []
      let yqData = []
      let n = 0
      for (const d of dayarr) {
        let zs = 0, wc = 0, yq = 0
        for (const t of taskdata) {
          const time = t.time.substring(0, 10)
          if (time === d) {
            zs++
          } else {
            const oDate1 = new Date(time)
            const oDate2 = new Date(d)
            if (oDate1.getTime() <= oDate2.getTime()) {
              zs++
            }
          }
          if (t.enddateReal !== null && t.enddateReal !== undefined && t.enddateReal !== '' && t.psid === 0) {
            const oDate1 = new Date(t.enddateReal)
            const oDate2 = new Date(d)
            if (oDate1.getTime() <= oDate2.getTime()) {
              wc++
            }
          }
          if (t.psid === 0) {
            if (d === t.enddate) {
              if (t.enddateReal !== null && t.enddateReal !== undefined && t.enddateReal !== '') {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  yq++
                }
              }
            }
          } else {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate !== d) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(d)
                if (oDate1.getTime() < oDate2.getTime()) {
                  yq++
                }
              }
            }
          }
        }
        zsData.push(zs)
        wcData.push(wc)
        yqData.push(yq)
        n++
      }
      const option = {
        title: false,
        tooltip: {
          trigger: 'axis'
        },
        color: ['#409EFF', '#67C23A', '#E6A23C'],
        grid: {
          left: '0',
          right: '20px',
          bottom: '0',
          top: '20px',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#404852'
          },
          axisLine: {
            lineStyle: {
              color: '#c5c5c5',
              width: 1
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '事项总数走势',
            type: 'line',
            smooth: true,
            showSymbol: true,
            data: zsData,
            lineStyle: {
              width: 1
            }
          },
          {
            name: '完成事项数走势',
            type: 'line',
            smooth: true,
            showSymbol: true,
            data: wcData,
            lineStyle: {
              width: 1
            }
          },
          {
            name: '逾期事项数走势',
            type: 'line',
            smooth: true,
            showSymbol: true,
            data: yqData,
            lineStyle: {
              width: 1
            }
          }
        ]
      }
      chart.setOption(option, true)
    },
    setTaskBurnOutChart(taskdata) {
      let chart = echarts.getInstanceByDom(document.getElementById('taskBurnOutChart'))
      if (chart == null) {
        chart = echarts.init(document.getElementById('taskBurnOutChart'))
      }
      chart.clear()
      let xAxisData = []
      let dayarr = []
      for (let d = this.project.startdate; d !== this.addDay(this.project.enddate, 1); d = this.addDay(d, 1)) {
        xAxisData.push(d.substring(5, d.length))
        dayarr.push(d)
      }
      let realData = []
      let planData = []
      let untasknum = taskdata.length / (dayarr.length - 1)
      let n = 0
      for (const d of dayarr) {
        planData.push((taskdata.length - untasknum * n).toFixed(1))
        let fn = 0
        for (const t of taskdata) {
          if (t.enddateReal !== null && t.enddateReal !== undefined && t.enddateReal !== '' && t.psid === 0) {
            const oDate1 = new Date(t.enddateReal)
            const oDate2 = new Date(d)
            if (oDate1.getTime() <= oDate2.getTime()) {
              fn++
            }
          }
        }
        realData.push(taskdata.length - fn)
        n++
      }
      const option = {
        title: false,
        tooltip: {
          trigger: 'axis'
        },
        color: ['#67C23A', '#409EFF'],
        grid: {
          left: '0',
          right: '20px',
          bottom: '0',
          top: '20px',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#404852'
          },
          axisLine: {
            lineStyle: {
              color: '#c5c5c5',
              width: 1
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '实际剩余事项数',
            type: 'line',
            smooth: true,
            showSymbol: true,
            data: realData,
            lineStyle: {
              width: 1
            }
          },
          {
            name: '计划剩余事项数',
            type: 'line',
            smooth: true,
            showSymbol: true,
            data: planData,
            lineStyle: {
              width: 1
            }
          }
        ]
      }
      chart.setOption(option, true)
    },
    setTaskUserChart(userChartDatas) {
      let chart = echarts.getInstanceByDom(document.getElementById('taskUserChart'))
      if (chart == null) {
        chart = echarts.init(document.getElementById('taskUserChart'))
      }
      chart.clear()
      const datas = [userChartDatas]
      const option = {
        legend: false,
        toolbox: false,
        series: datas.map(function(data, idx) {
          var top = idx * 100
          return {
            type: 'pie',
            top: top + '%',
            height: '100%',
            left: 'center',
            width: '100%',
            radius: [30, 140],
            roseType: 'area',
            itemStyle: {
              borderRadius: 8
            },
            label: {
              alignTo: 'edge',
              formatter: '{name|{b}} {d}%\n{time|{c} 个事项}',
              minMargin: 5,
              edgeDistance: 0,
              lineHeight: 20,
              fontSize: 13,
              rich: {
                time: {
                  fontSize: 13,
                  color: '#999'
                }
              }
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80
            },
            labelLayout: function(params) {
              const isLeft = params.labelRect.x < chart.getWidth() / 2
              const points = params.labelLinePoints
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width
              return {
                labelLinePoints: points
              }
            },
            data: data
          }
        })
      }
      chart.setOption(option, true)
    },
    setTaskChaet(userChartDatas) {
      let chart = echarts.getInstanceByDom(document.getElementById('taskChart'))
      if (chart == null) {
        chart = echarts.init(document.getElementById('taskChart'))
      }
      chart.clear()
      let xAxisData = []
      let valData = []
      for (const t of userChartDatas) {
        xAxisData.push(t.name)
        valData.push(t.value)
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: ['#409EFF'],
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              color: '#404852'
            },
            axisLine: {
              lineStyle: {
                color: '#c5c5c5',
                width: 1
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: '事项数',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            label: {
              show: true,
              position: 'top'
            },
            data: valData
          }
        ]
      }
      chart.setOption(option, true)
    },
    getChartData() {
      this.chartLoading = true
      getProjectTaskListByPid({ pid: this.project.pid }).then(response => {
        let userChartDatas = []
        for (const t of response.data) {
          let ishave = false
          for (const u of userChartDatas) {
            if (u.userid === t.userid) {
              ishave = true
              u.value = u.value + 1
              break
            }
          }
          if (!ishave) {
            userChartDatas.push({
              userid: t.userid,
              name: t.userid === 0 ? '待认领' : t.username,
              value: 1
            })
          }
        }
        this.setTaskUserChart(userChartDatas)
        this.setTaskChaet(userChartDatas)
        this.setTaskBurnOutChart(response.data)
        this.setProjectProgressTrendChart(response.data)
        this.chartLoading = false
      })
    },
    setOverviewChange(n) {
      this.overviewChange = n
      this.filterOverviewData()
    },
    filterOverviewData() {
      let _overviewData = []
      const newDate = new Date()
      const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
      for (const t of this.overviewBaseData) {
        if (this.overviewChange === 0) {
          _overviewData.push(t)
        } else if (this.overviewChange === 1) {
          if (t.psid === 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 2) {
          if (t.psid !== 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 3) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        } else if (this.overviewChange === 4) {
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 5) {
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 6) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _overviewData.push(t)
              }
            }
          }
        } else if (this.overviewChange === 7) {
          if (t.psid === 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        }
      }
      this.overviewData = _overviewData
    },
    getOverviewData() {
      this.overviewLoading = true
      getProjectTaskListByPid({ pid: this.project.pid }).then(response => {
        this.overviewBaseData = response.data
        let _ywc = 0, _wwc = 0, _yyq = 0, _drl = 0, _sjdd = 0, _jrdq = 0, _yqwc = 0
        const newDate = new Date()
        const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
        let unp = 0.0
        let _projectPercent = 0.0
        if (response.data.length > 0) {
          unp = 100 / response.data.length
        }
        for (const t of response.data) {
          if (t.psid === 0) {
            _projectPercent = _projectPercent + unp
            _ywc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yqwc++
                }
              }
            }
          } else {
            if (t.percent > 0) {
              _projectPercent = _projectPercent + (t.percent / 100 * unp)
            }
            _wwc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _jrdq++
              } else {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yyq++
                }
              }
            }
          }
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _drl++
          }
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _sjdd++
          }
        }
        this.projectPercent = Math.floor(_projectPercent)
        this.overviewNum = {
          zs: response.data.length,
          ywc: _ywc,
          wwc: _wwc,
          yyq: _yyq,
          drl: _drl,
          sjdd: _sjdd,
          jrdq: _jrdq,
          yqwc: _yqwc
        }
        this.filterOverviewData()
        this.overviewLoading = false
      })
    },
    changePercent(val) {
      const data = {
        ptid: this.taskDetail.ptid,
        percent: val,
        userid: this.user.dUserid
      }
      editProjectTaskPercent(data)
    },
    successAddProjectFile(response, file, fileList) {
      if (response.success) {
        const data = {
          pid: this.project.pid,
          pnid: this.fileSxData[this.fileSxData.length - 1].pfid,
          type: 1,
          userid: this.user.dUserid,
          fileid: response.data.dFileid
        }
        addProjectFile(data).then(response => {
          // this.$message({
          //   type: 'success',
          //   message: '创建成功'
          // })
          this.getFiles()
        }).catch(() => {})
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    renameFile(row) {
      this.$prompt('请输入文件夹名称', '文件夹重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.name,
        inputPattern: /\S/,
        inputErrorMessage: '文件夹不可为空'
      }).then(({ value }) => {
        const data = {
          pfid: row.pfid,
          name: value,
          type: 1
        }
        editProjectFile(data).then(response => {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getFiles()
        })
      }).catch(() => {})
    },
    delProjectFile(row) {
      this.$confirm(`${row.type === 1 ? '您确定要删除此文件吗?' : '将此文件夹及所有文件删除，确定吗？'}`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          pfid: row.pfid,
          type: 0
        }
        editProjectFile(data).then(response => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getFiles()
        })
      })
    },
    setFileSx(index) {
      let _fileSxData = []
      for (let i = 0; i < this.fileSxData.length; i++) {
        _fileSxData.push(this.fileSxData[i])
        if (i === index) {
          break
        }
      }
      this.fileSxData = _fileSxData
      this.filterFiles()
    },
    openFileDetails(row) {
      if (row.type === 1) {
        this.downFile(row.fileid)
      } else {
        this.fileSxData.push(row)
        this.filterFiles()
      }
    },
    subAddFolder() {
      if (!this.editLoading) {
        if (this.foldername !== null && this.foldername !== undefined && this.foldername.trim() !== '') {
          this.editLoading = true
          const data = {
            pid: this.project.pid,
            pnid: this.fileSxData[this.fileSxData.length - 1].pfid,
            type: 0,
            name: this.foldername,
            userid: this.user.dUserid
          }
          addProjectFile(data).then(response => {
            this.$message({
              type: 'success',
              message: '创建成功'
            })
            this.addFolderVisible = false
            this.foldername = ''
            this.editLoading = false
            this.getFiles()
          }).catch(() => {
            this.editLoading = false
          })
        } else {
          this.$message.error('文件夹名称不能为空')
        }
      }
    },
    filterFiles() {
      const pnid = this.fileSxData[this.fileSxData.length - 1].pfid
      let _fileData = []
      for (const f of this.fileBaseData) {
        if (pnid === f.pnid) {
          _fileData.push(f)
        }
      }
      this.fileData = _fileData
    },
    getFiles() {
      this.fileData = []
      this.fileLoading = true
      getProjectFileList({ pid: this.project.pid }).then(response => {
        this.fileBaseData = response.data
        for (const f of this.fileBaseData) {
          f.time = formatDate(Date.parse(f.time))
        }
        this.filterFiles()
        this.fileLoading = false
      }).catch(() => {
        this.fileLoading = false
      })
    },
    handleTabClick(tab, event) {
      if (tab.index === 1) {
        this.SearchDynamic()
      }
    },
    SearchDynamic() {
      this.dynamicLoading = true
      let _startdate = '', _enddate = ''
      if (this.searchForm.time.length === 2) {
        _startdate = this.searchForm.time[0]
        _enddate = this.searchForm.time[1]
      }
      const data = {
        pid: this.project.pid,
        ptid: this.searchForm.ptid,
        search: this.searchForm.search,
        startdate: _startdate,
        enddate: _enddate
      }
      getProjectDynamicList(data).then(response => {
        this.dynamicBaseList = response.data
        this.filterDynamic()
        this.dynamicLoading = false
      })
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                  href: response.data.copyPath,
                  target: '_blank',
                  download: `${response.data.dName}.${response.data.dType}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    subTaskDynamic(ptid) {
      if (!this.editLoading) {
        if (this.dynamicContent === null || this.dynamicContent === undefined || this.dynamicContent.trim() === '') {
          if (this.fileids.length <= 0) {
            this.$message.error('评论内容不能为空')
            return
          }
        }
        this.editLoading = true
        const data = {
          pid: this.project.pid,
          ptid: ptid,
          userid: this.user.dUserid,
          content: this.dynamicContent,
          fileids: this.fileids.join(',')
        }
        addProjectDynamic(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.dynamicContent = ''
          this.fileids = []
          this.$refs['multiUploadFile'].clearFiles()
          this.editLoading = false
          this.getProjectDynamic(ptid)
        }).catch(() => {
          this.editLoading = false
        })
      }
    },
    handleFileRemove(file, fileList) {
      if (file.response !== undefined && file.response.data !== null) {
        const i = this.fileids.indexOf(file.response.data.dFileid)
        if (i !== -1) {
          this.fileids.splice(i, 1)
        }
      } else {
        if (file.id !== undefined && file.id !== null) {
          const i = this.fileids.indexOf(file.id)
          if (i !== -1) {
            this.fileids.splice(i, 1)
          }
        }
      }
    },
    beforeFileRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name} ？`)
    },
    successMultiFile(response, file, fileList) {
      if (response.success) {
        this.fileids.push(response.data.dFileid)
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    errorMultiFile() {
      this.$message({
        type: 'error',
        message: '文件上传失败，请稍后重试'
      })
    },
    handleFileExceed(files, fileList) {
      this.$message.warning(`最多上传 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    setDynamicTab(n) {
      this.dynamicTab = n
      this.dynamicList = []
      this.filterDynamic()
    },
    filterDynamic() {
      let _dynamicList = []
      for (const d of this.dynamicBaseList) {
        d.time = formatDate(Date.parse(d.time))
        if (this.dynamicTab === 1) {
          if (d.filelst.length <= 0) {
            _dynamicList.push(d)
          }
        } else if (this.dynamicTab === 2) {
          if (d.filelst.length > 0) {
            _dynamicList.push(d)
          }
        } else {
          _dynamicList.push(d)
        }
      }
      this.dynamicList = _dynamicList
    },
    getProjectDynamic(ptid) {
      this.dynamicLoading = true
      const data = {
        pid: this.project.pid,
        ptid: ptid
      }
      getProjectDynamicList(data).then(response => {
        this.dynamicBaseList = response.data
        this.filterDynamic()
        this.dynamicLoading = false
      })
    },
    subTaskTimeJH(pt) {
      const oldsd = pt.startdate
      const olded = pt.enddate
      pt.startdate = pt.jhtime[0]
      pt.enddate = pt.jhtime[1]
      const data = {
        ptid: pt.ptid,
        operuserid: this.user.dUserid,
        startdate: pt.jhtime[0],
        enddate: pt.jhtime[1]
      }
      editProjectTaskInfo(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
        this.refTaskOutime()
      }).catch(() => {
        pt.startdate = oldsd
        pt.enddate = olded
      })
    },
    setTaskUserZP(pt, u) {
      const oldphoto = pt.userphoto
      const olduserid = pt.userid
      const oldname = pt.username
      pt.userid = u.userid
      pt.username = u.name
      pt.userphoto = u.photo
      const data = {
        ptid: pt.ptid,
        operuserid: this.user.dUserid,
        userid: u.userid
      }
      editProjectTaskInfo(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
      }).catch(() => {
        pt.userphoto = oldphoto
        pt.userid = olduserid
        pt.username = oldname
      })
    },
    delTask() {
      if (!this.edittaskloading) {
        this.edittaskloading = true
        const data = {
          ptid: this.taskDetail.ptid,
          userid: this.user.dUserid
        }
        delProjectTask(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.taskVisible = false
          this.edittaskloading = false
          this.getData()
        }).catch(() => {
          this.edittaskloading = false
        })
      }
    },
    subAddTask() {
      this.$refs['addTaskForm'].validate((valid) => {
        if (valid && !this.edittaskloading) {
          this.edittaskloading = true
          let _startdate = '', _enddate = ''
          if (this.addTaskForm.time.length === 2) {
            _startdate = this.addTaskForm.time[0]
            _enddate = this.addTaskForm.time[1]
          }
          const data = {
            pid: this.project.pid,
            taskname: this.addTaskForm.taskname,
            remark: this.addTaskForm.remark,
            userid: this.addTaskForm.userid,
            priority: this.addTaskForm.priority,
            psid: this.addTaskForm.psid,
            startdate: _startdate,
            enddate: _enddate,
            operuserid: this.user.dUserid
          }
          addProjectTask(data).then(response => {
            this.$message({
              type: 'success',
              message: response.msg
            })
            this.addTaskVisible = false
            this.edittaskloading = false
            this.getData()
          }).catch(() => {
            this.edittaskloading = false
          })
        }
      })
    },
    addTask(psid) {
      this.addTaskForm = {
        taskname: '',
        remark: '',
        userid: 0,
        priority: 0,
        psid: psid,
        time: []
      }
      this.addTaskVisible = true
    },
    delTaskTag(t) {
      let _taglist = this.taskDetail.taglist
      const index = _taglist.indexOf(t)
      _taglist.splice(index, 1)
      this.taskDetail.taglist = _taglist
      const data = {
        ptid: this.taskDetail.ptid,
        pttid: t.pttid,
        type: 0,
        userid: this.user.dUserid
      }
      addOrDelProjectTaskTag(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
      }).catch(() => {
        _taglist.splice(index, 1, t)
        this.taskDetail.taglist = _taglist
      })
    },
    subTaskTag() {
      if (this.taskForm.tagname !== null && this.taskForm.tagname !== undefined && this.taskForm.tagname !== '') {
        this.edittaskloading = true
        const data = {
          ptid: this.taskDetail.ptid,
          pttid: 0,
          tag: this.taskForm.tagname,
          color: this.taskForm.tagcolor,
          type: 1,
          userid: this.user.dUserid
        }
        addOrDelProjectTaskTag(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          let _taglist = this.taskDetail.taglist
          _taglist.push({
            pttid: response.data,
            ptid: this.taskDetail.ptid,
            tag: this.taskForm.tagname,
            color: this.taskForm.tagcolor
          })
          this.taskDetail.taglist = _taglist
          this.taskForm.tagname = ''
          this.taskForm.tagcolor = 'blue'
          this.edittaskloading = false
          this.taskForm.tagVisible = false
        }).catch(() => {
          this.edittaskloading = false
        })
      } else {
        this.$message.error('标签名称不能为空')
      }
    },
    refTaskOutime() {
      for (let t of this.tasklist) {
        let _jhtime = []
        if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.startdate !== null && t.startdate !== undefined && t.startdate !== '') {
          _jhtime.push(t.startdate)
          _jhtime.push(t.enddate)
        }
        t.jhtime = _jhtime
        if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== null && t.enddateReal !== undefined && t.enddateReal !== '') {

          if (t.enddate === t.enddateReal) {
            t.isouttime = 0
          } else {
            const oDate1 = new Date(t.enddate)
            const oDate2 = new Date(t.enddateReal)
            if (oDate1.getTime() > oDate2.getTime()) {
              t.isouttime = 0
            } else {
              t.isouttime = 1
            }
          }
        }
      }
    },
    subTaskRealTime(t) {
      const oldsd = this.taskDetail.startdateReal
      const olded = this.taskDetail.enddateReal
      this.taskDetail.startdateReal = t[0]
      this.taskDetail.enddateReal = t[1]
      const data = {
        ptid: this.taskDetail.ptid,
        operuserid: this.user.dUserid,
        startdatereal: t[0],
        enddatereal: t[1]
      }
      editProjectTaskInfo(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
        this.refTaskOutime()
      }).catch(() => {
        this.taskDetail.startdateReal = oldsd
        this.taskDetail.enddateReal = olded
      })
    },
    subTaskPriority(n) {
      const oldPriority = this.taskDetail.priority
      this.taskDetail.priority = n
      const data = {
        ptid: this.taskDetail.ptid,
        operuserid: this.user.dUserid,
        priority: n
      }
      editProjectTaskInfo(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
      }).catch(() => {
        this.taskDetail.priority = oldPriority
      })
    },
    subTaskRemark() {
      if (this.taskForm.remark !== null && this.taskForm.remark !== undefined && this.taskForm.remark !== '') {
        this.edittaskloading = true
        const data = {
          ptid: this.taskDetail.ptid,
          operuserid: this.user.dUserid,
          remark: this.taskForm.remark
        }
        editProjectTaskInfo(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.taskDetail.remark = this.taskForm.remark
          this.edittaskloading = false
          this.taskForm.reamrkVisible = false
        }).catch(() => {
          this.edittaskloading = false
        })
      } else {
        this.$message.error('事项说明不能为空')
      }
    },
    subTaskTime(t) {
      const oldsd = this.taskDetail.startdate
      const olded = this.taskDetail.enddate
      this.taskDetail.startdate = t[0]
      this.taskDetail.enddate = t[1]
      const data = {
        ptid: this.taskDetail.ptid,
        operuserid: this.user.dUserid,
        startdate: t[0],
        enddate: t[1]
      }
      editProjectTaskInfo(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
        this.refTaskOutime()
      }).catch(() => {
        this.taskDetail.startdate = oldsd
        this.taskDetail.enddate = olded
      })
    },
    setTaskUser(userid) {
      const oldphoto = this.taskDetail.userphoto
      const olduserid = this.taskDetail.userid
      const oldname = this.taskDetail.username
      this.taskDetail.userid = userid
      if (userid === this.project.userid) {
        this.taskDetail.userphoto = this.project.userphoto
        this.taskDetail.username = this.project.username
      } else {
        for (const u of this.project.teamlist) {
          if (u.userid === userid) {
            this.taskDetail.userphoto = u.photo
            this.taskDetail.username = u.name
            break
          }
        }
      }
      const data = {
        ptid: this.taskDetail.ptid,
        operuserid: this.user.dUserid,
        userid: userid
      }
      editProjectTaskInfo(data).then(response => {
        // this.$message({
        //   type: 'success',
        //   message: response.msg
        // })
      }).catch(() => {
        this.taskDetail.userphoto = oldphoto
        this.taskDetail.userid = olduserid
        this.taskDetail.username = oldname
      })
    },
    subTaskName() {
      if (this.taskForm.taskname !== null && this.taskForm.taskname !== undefined && this.taskForm.taskname !== '') {
        this.edittaskloading = true
        const data = {
          ptid: this.taskDetail.ptid,
          operuserid: this.user.dUserid,
          taskname: this.taskForm.taskname
        }
        editProjectTaskInfo(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.taskDetail.taskname = this.taskForm.taskname
          this.edittaskloading = false
          this.taskForm.nameVisible = false
        }).catch(() => {
          this.edittaskloading = false
        })
      } else {
        this.$message.error('事项名称不能为空')
      }
    },
    viewTask(t) {
      this.taskDetail = t
      let _stagename = ''
      for (const s of this.stagelist) {
        if (s.psid === t.psid) {
          _stagename = s.stagename
          break
        }
      }
      this.taskForm = {
        nameVisible: false,
        taskname: t.taskname,
        namekey: new Date().getTime() + 2,
        time: [t.startdate, t.enddate],
        reamrkVisible: false,
        remark: t.remark,
        tagVisible: false,
        tagname: '',
        tagcolor: 'blue',
        realtime: [t.startdateReal, t.enddateReal],
        remarkkey: new Date().getTime(),
        tagkey: new Date().getTime() + 1,
        stagename: _stagename
      }
      this.fileids = []
      this.dynamicContent = ''
      this.dynamicTab = 0
      this.dynamicList = []
      this.dynamicBaseList = []
      this.taskVisible = true
      this.getProjectDynamic(t.ptid)
    },
    editTaskStage(t, oldpsid) {
      for (const s of this.stagelist) {
        if (s.psid === t.psid) {
          this.taskForm.stagename = s.stagename
          break
        }
      }
      const data = {
        ptid: t.ptid,
        psid: t.psid,
        userid: this.user.dUserid
      }
      editProjectTaskStage(data).then(response => {
        this.dragStageid = null
        this.dragTask = null
        if (this.taskDetail.ptid !== null && this.taskDetail.ptid !== undefined && this.taskDetail.ptid !== '') {
          this.taskDetail.psid = t.psid
        }
        this.refTaskOpen()
      }).catch(() => {
        for (let te of this.tasklist) {
          if (te.ptid === t.ptid) {
            te.psid = oldpsid
            this.dragStageid = null
            this.dragTask = null
            break
          }
        }
      })
    },
    dragStart(e, item) {
      e.dataTransfer.setData('aaa', null)
      this.isTaskdrag = true
      this.dragTask = item
    },
    dragDrop(e) {
      this.isTaskdrag = false
      if (this.dragStageid !== null && this.dragStageid !== undefined && this.dragTask !== null && this.dragTask !== undefined) {
        for (let t of this.tasklist) {
          if (t.ptid === this.dragTask.ptid) {
            const oldpsid = t.psid
            t.psid = this.dragStageid
            this.dragStageid = null
            this.dragTask = null
            this.editTaskStage(t, oldpsid)
            break
          }
        }
      } else {
        this.dragStageid = null
        this.dragTask = null
      }
    },
    dragEnter(e, s) {
      if (s.psid !== this.dragTask.psid) {
        if (this.isTaskdrag) {
          this.dragStageid = s.psid
        }
      } else {
        this.dragStageid = null
      }
    },
    dragOver(e) {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
    },
    dragEnd(e) {
      this.dragStageid = null
      this.dragTask = null
    },
    exportStageTask(s) {
      const data = {
        psid: s.psid,
        pid: this.project.pid,
        isopen: this.showUnopened ? 1 : 0
      }
      exportProjectTaskExcel(data).then(response => {
        this.exportLoading = false
        const _this = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = this.response
            const a = document.createElement('a')
            a.download = response.data.dName + '' + response.data.dataType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  {
                    attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }
                  }, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      }).catch(() => {
        this.$message.error('导出失败')
      })
    },
    delStage(s) {
      this.$confirm('删除此阶段后该阶段下所有的事项都将移动至未开始阶段，确认删除吗?', '删除阶段', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          pid: s.pid,
          psid: s.psid,
          xh: s.xh,
          name: s.stagename,
          userid: this.user.dUserid,
          type: 2
        }
        editProjectStage(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      })
    },
    subEditStage() {
      if (!this.editLoading) {
        if (this.stageForm.name !== null && this.stageForm.name !== undefined && this.stageForm.name !== '') {
          this.editLoading = true
          const data = {
            pid: this.project.pid,
            psid: this.stageForm.psid,
            xh: this.stageForm.xh,
            name: this.stageForm.name,
            userid: this.user.dUserid,
            type: this.stageForm.psid === 0 ? 0 : 1
          }
          editProjectStage(data).then(response => {
            this.$message({
              type: 'success',
              message: response.msg
            })
            this.editLoading = false
            this.editStageVisible = false
            if (this.stageForm.psid === 0) {
              let idx = 0
              for (let s of this.stagelist) {
                idx++
                if (s.psid === this.stageForm.oldid) {
                  break
                }
              }
              this.stagelist.splice(idx, 0, {
                psid: response.data,
                xh: this.stageForm.xh,
                stagename: this.stageForm.name,
                pid: this.project.pid,
                status: 1
              })
            } else {
              for (let s of this.stagelist) {
                if (s.psid === this.stageForm.psid) {
                  s.stagename = this.stageForm.name
                }
              }
            }
          }).catch(() => {
            this.editLoading = false
          })
        } else {
          this.$message.error('阶段名称不可为空')
        }
      }
    },
    editStage(row, xh) {
      if (row !== null) {
        this.editStageTitle = '编辑阶段'
        this.stageForm = {
          psid: row.psid,
          xh: xh,
          name: row.stagename
        }
      } else {
        this.editStageTitle = '添加阶段'
        this.stageForm = {
          psid: 0,
          xh: xh.xh,
          name: '',
          oldid: xh.psid
        }
      }
      this.editStageVisible = true
    },
    searchTask(v) {
      let _tasklist = []
      for (const t of this.taskbaselist) {
        if (v !== null && v !== undefined && v.trim() !== '') {
          if (t.taskname.indexOf(v.trim()) >= 0) {
            _tasklist.push(t)
          }
        } else {
          _tasklist.push(t)
        }
      }
      this.tasklist = _tasklist
      this.refTaskOpen()
    },
    refTaskOpen() {
      for (let t of this.tasklist) {
        if (t.opencond !== undefined && t.opencond !== null && t.opencond !== '') {
          let fnum = 0
          let arr = t.opencond.split(',')
          for (const id of arr) {
            let isf = false
            for (let te of this.tasklist) {
              if (id === te.ptid && te.psid === 0) {
                isf = true
                break
              }
            }
            if (isf) {
              fnum++
            }
          }
          if (fnum === arr.length) {
            t.isopen = 1
          } else {
            t.isopen = 0
          }
        } else {
          t.isopen = 1
        }
      }
      this.taskBoxKey = new Date().getTime()
    },
    getTask() {
      getProjectTaskListByPid({ pid: this.project.pid }).then(response => {
        this.taskbaselist = response.data
        this.tasklist = response.data
        for (let t of this.tasklist) {
          if (t.startdate !== null && t.startdate !== undefined && t.startdate !== '' && t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
            let _jhtime = []
            _jhtime.push(t.startdate)
            _jhtime.push(t.enddate)
            t.jhtime = _jhtime
          }
        }
        this.refTaskOpen()
      })
    },
    getData() {
      this.loading = true
      selectByIdProject({ pid: this.pid }).then(response => {
        this.loading = false
        this.project = response.data
        const pageTitle = `${response.data.name}`
        this.assignInfo = response.data.assignInfo
        if (pageTitle.length > 10) {
          document.title = pageTitle.substring(0, 10) + '...'
        } else {
          document.title = pageTitle
        }
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        let _projectTeamAllname = [this.project.username]
        for (const u of this.project.teamlist) {
          _projectTeamAllname.push(u.name)
        }
        this.projectTeamAllname = _projectTeamAllname.join('、')
        if (this.project.userid === this.user.dUserid) {
          this.isadmin = true
        } else {
          for (const u of this.project.teamlist) {
            if (u.userid === this.user.dUserid && u.role === 1) {
              this.isadmin = true
            }
          }
        }
        let _time = []
        _time.push(this.project.startdate)
        _time.push(this.project.enddate)
        this.eForm = {
          pid: this.project.pid,
          name: this.project.name,
          explain: this.project.explain,
          time: _time,
          mark: this.project.mark
        }
        this.stagelist = response.data.stagelist
        this.getDeptEmployeeTree()
        this.getTask()
      }).catch(() => {
        this.loading = false
      })
    },
    subEditInfo() {
      this.$refs['eForm'].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            this.editLoading = true
            const data = {
              pid: this.eForm.pid,
              name: this.eForm.name,
              explain: this.eForm.explain,
              startdate: this.eForm.time[0],
              enddate: this.eForm.time[1],
              mark: this.eForm.mark,
              userid: this.user.dUserid
            }
            editProjectSetInfo(data).then(response => {
              this.$message({
                type: 'success',
                message: response.msg
              })
              this.editLoading = false
              this.projectInfoVisible = false
              this.getData()
            }).catch(() => {
              this.editLoading = false
            })
          }
        }
      })
    },
    addTeam() {
      if (!this.addTeamLoading) {
        let _userids = []
        for (const userlst of this.changeTeamUser) {
          for (const user of userlst) {
            if (user.indexOf('user@') >= 0) {
              let ishave = false
              const userid = parseInt(user.split('@')[1])
              for (const ut of this.project.teamlist) {
                if (ut.userid === userid) {
                  ishave = true
                  break
                }
              }
              if (!ishave) {
                if (userid !== this.project.userid) {
                  _userids.push(userid)
                }
              }
            }
          }
        }
        if (_userids.length <= 0) {
          this.$message.error('至少选择一个成员')
          return
        }
        this.addTeamLoading = true
        const data = {
          pid: this.pid,
          userid: _userids.join(','),
          role: 0,
          operuserid: this.user.dUserid,
          type: 0
        }
        projectTeamEdit(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.changeTeamUser = []
          this.addTeamLoading = false
          this.getData()
        }).catch(() => {
          this.addTeamLoading = false
        })
      }
    },
    editTeam(u) {
      const data = {
        pid: this.pid,
        userid: u.userid,
        role: u.role === 1 ? 0 : 1,
        operuserid: this.user.dUserid,
        type: 1
      }
      projectTeamEdit(data).then(response => {
        this.$message({
          type: 'success',
          message: response.msg
        })
        for (const ut of this.project.teamlist) {
          if (ut.userid === u.userid) {
            ut.role = u.role === 1 ? 0 : 1
          }
        }
      })
    },
    delTeam(u) {
      this.$confirm('确定移除此项目成员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          pid: this.pid,
          userid: u.userid,
          role: u.role,
          operuserid: this.user.dUserid,
          type: 2
        }
        projectTeamEdit(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      })
    },
    getDeptEmployeeTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptEmployeeTree(data).then(response => {
        this.deptEmployeeTree = response.data
        this.filterUserTree(this.deptEmployeeTree)
      }).catch(() => {})
    },
    filterUserTree(tree) {
      for (let t of tree) {
        const userid = 'user@' + this.project.userid
        if (t.value === userid) {
          t.disabled = true
        } else {
          for (const u of this.project.teamlist) {
            const tuserid = 'user@' + u.userid
            if (t.value === tuserid) {
              t.disabled = true
            }
          }
        }
        if (t.children !== undefined) {
          this.filterUserTree(t.children)
        }
      }
    },
    dateToWz(d) {
      if (d !== null && d !== undefined) {
        if (d.length > 10) {
          d = d.substring(0, 10)
        }
        const darr = d.split('-')
        return darr[0] + '年' + darr[1] + '月' + darr[2] + '日'
      } else {
        return ''
      }
    },
    addDay(d, n) {
      let dataTime = new Date(d)
      dataTime = dataTime.setDate(dataTime.getDate() + n)
      dataTime = new Date(dataTime)
      const day = dataTime.getDate()
      const month = dataTime.getMonth() + 1
      const year = dataTime.getFullYear()
      return `${year}-${month > 10 ? month : `0${month}`}-${day > 9 ? day : `0${day}`}`
    }
  }
}
</script>

<style lang="scss" scoped>
.project-container{
  width: 100%;
  position: relative;
  height: 100%;
  .header{
    width: 100%;
    background: #ffffff;
    border-left: 1px solid #f5f7fa;
    border-bottom: 1px solid #f0f0f0;
    .project-info{
      padding: 10px 0 0 15px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      .el-icon-info{
        color: #bfbfbf;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .project-tab{
      padding: 0 15px;
    }
    .right-menu{
      padding-right: 15px;
      line-height: 90px;
      text-align: right;
      position: relative;
      .set-btn{
        margin-left: 10px;
        font-size: 14px;
        cursor: pointer;
        color: #8c8c8c;
        &:hover{
          color: #262626;
        }
      }
      .team-info{
        position: absolute;
        right: 130px;
        top: 0;
        height: 90px;
        display: flex;
        justify-items: center;
        align-items: center;
        span{
          margin-right: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .task-box{
    -ms-flex-positive: 1;
    box-sizing: border-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-grow: 1;
    flex-grow: 1;
    height: calc(100% - 92px);
    overflow: hidden;
    width: 100%;
    z-index: 1;
    .task-top{
      border-left: 1px solid #f5f7fa;
      -ms-flex-pack: justify;
      background-color: #fff;
      color: #8c8c8c;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      height: 40px;
      -webkit-justify-content: space-between;
      justify-content: space-between;
      padding: 12px 15px;
      width: 100%;
      .task-top-left{
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;

      }
      .task-top-right{
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        .top-filter{
          font-size: 12px;
          background: #f2fbff;
          color: #1b9aee;
          height: 28px;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 80px;
          cursor: pointer;
          &:hover{
            color: #0171c2;
          }
        }
      }
    }
    .task-panel{
      width: 100%;
      position: absolute;
      overflow: auto;
      height: calc(100% - 132px);
      top: 132px;
      left: 0;
      .panel-list{
        position: relative;
        padding: 10px 15px;
        -ms-flex-align: start;
        -webkit-align-items: flex-start;
        align-items: flex-start;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        overflow: auto;
        overflow-anchor: none;
        .panel-item{
          -ms-flex-negative: 0;
          -webkit-flex-shrink: 0;
          flex-shrink: 0;
          height: 100%;
          width: 296px;
          margin-left: 24px;
          &:first-child{
            margin-left: 0;
          }
          .task-stage{
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            height: 48px;
            width: 100%;
            .tit{
              -ms-flex-positive: 1;
              -webkit-flex-grow: 1;
              flex-grow: 1;
              overflow: hidden;
              font-size: 14px;
              font-weight: 700;
              text-overflow: ellipsis;
              white-space: nowrap;
              -webkit-align-items: center;
              align-items: center;
              display: -webkit-flex;
              display: -ms-flexbox;
              display: flex;
              height: 100%;
            }
            .btn{
              -ms-flex-negative: 0;
              -webkit-flex-shrink: 0;
              flex-shrink: 0;
              color: #bfbfbf;
              cursor: pointer;
              &:hover{
                color: #409EFF;
              }
            }
          }
          .task-card{
            width: 100%;
            height: calc(100% - 48px);
            position: relative;
            -webkit-flex: 0 0 auto;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto;
            min-height: 96px;
            overflow-anchor: none;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            .drag-area{
              width: 100%;
              height: 100%;
              background: #fff;
              border: 2px solid #409EFF;
              position: absolute;
              top: 0;
              left: 0;
              color: #409EFF;
              font-size: 14px;
              font-weight: bold;
              padding: 20px;
              border-radius: 4px;
              z-index: 6;
            }
            .task-list{
              overflow-x: hidden;
              overflow-y: auto;
              position: relative;
              .task-item{
                margin-bottom: 8px;
                outline: none;
                cursor: pointer;
                -webkit-touch-callout: none;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                touch-action: manipulation;
                width: 100%;
                .task-content-box{
                  background-color: #fff;
                  border-radius: 4px;
                  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.1);
                  position: relative;
                  white-space: normal;
                  width: 100%;
                  padding: 12px 12px 12px 20px;
                  .not-open{
                    width: 100%;
                    height: 100%;
                    left: 0;
                    position: absolute;
                    top: 0;
                    z-index: 2;
                    background: rgba(255,255,255,0.8);
                  }
                  .is-finsh{
                    background: rgba(255,255,255,0.5);
                  }
                  .task-priority{
                    border-bottom-left-radius: 4px;
                    border-top-left-radius: 4px;
                    bottom: 0;
                    left: 0;
                    position: absolute;
                    top: 0;
                    transition: width 218ms ease-in;
                    width: 4px;
                    z-index: 1;
                  }
                  .task-header{
                    min-height: 20px;
                    -ms-flex-align: start;
                    -ms-flex-pack: justify;
                    -webkit-align-items: flex-start;
                    align-items: flex-start;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-flex: 1 1 auto;
                    -ms-flex: 1 1 auto;
                    flex: 1 1 auto;
                    -webkit-flex-direction: row;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    .task-text{
                      word-wrap: break-word;
                      -webkit-flex: 1;
                      -ms-flex: 1;
                      flex: 1;
                      min-width: 0;
                      overflow: hidden;
                      font-size: 14px;
                    }
                  }
                  .task-tags{
                    line-height: 16px;
                    margin-top: 8px;
                    .tag{
                      color: #8c8c8c;
                      display: inline-block;
                      font-size: 12px;
                      height: 20px;
                      line-height: 20px;
                      margin: 2px 6px 0 0;
                      max-width: 100%;
                      padding: 0 4px;
                      vertical-align: middle;
                      &:before{
                        border-radius: 50%;
                        content: " ";
                        display: inline-block;
                        height: 6px;
                        margin-bottom: 2px;
                        margin-right: 6px;
                        width: 6px;
                      }
                    }
                    .tag-blue{
                      &:before{
                        background-color: #409EFF;
                      }
                    }
                    .tag-green{
                      &:before{
                        background-color: #67C23A;
                      }
                    }
                    .tag-yellow{
                      &:before{
                        background-color: #E6A23C;
                      }
                    }
                    .tag-red{
                      &:before{
                        background-color: #F56C6C;
                      }
                    }
                    .tag-gray{
                      &:before{
                        background-color: #909399;
                      }
                    }
                  }
                  .task-date{
                    line-height: 16px;
                    margin-top: 8px;
                    font-size: 12px;
                    color: #8c8c8c;
                    .time-out{
                      background: #F56C6C;
                      color: #fff;
                    }
                  }
                  .task-percent{
                    margin-top: 8px;
                  }
                }
                &:hover{
                  .task-priority{
                    width: 8px;
                  }
                }
              }
            }
            .task-add{
              -ms-flex-negative: 0;
              -ms-flex-positive: 1;
              display: -webkit-flex;
              display: -ms-flexbox;
              display: flex;
              -webkit-flex-direction: column;
              -ms-flex-direction: column;
              flex-direction: column;
              -webkit-flex-grow: 1;
              flex-grow: 1;
              -webkit-flex-shrink: 0;
              flex-shrink: 0;
              margin-top: 8px;
              .task-add-btn{
                background-color: #fff;
                border-radius: 4px;
                box-shadow: 0 1px 2px rgba(0,0,0,0.1);
                cursor: pointer;
                height: 28px;
                text-align: center;
                width: 100%;
                color: #8c8c8c;
                &:hover{
                  color: #409EFF;
                }
              }
            }
          }
        }
      }
    }
  }
}
.team-user-list{
  width: 100%;
  position: relative;
  .team-user-item{
    width: 100%;
    position: relative;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-items: center;
    align-items: center;
    cursor: pointer;
    padding: 0 10px;
    &:hover{
      background: #f0f0f0;
    }
    .name{
      margin: 0 10px;
      font-weight: 500;
    }
    .btn{
      position: absolute;
      right: 10px;
      top: 0;
      font-size: 12px;
      color: #8c8c8c;
      .d{
        &:first-child{
          margin-right: 10px;
        }
        &:hover{
          color: #262626;
        }
      }
    }
  }
}
.team-add-box{
  display: flex;
  justify-items: center;
  align-items: center;
  margin-bottom: 20px;
}
.task-info-box{
  position: relative;
  padding-right: 20px;
  .task-name{
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    color: #262626;
    cursor: pointer;
  }
  .task-form{
    width: 100%;
    position: relative;
    padding-left: 160px;
    margin-bottom: 18px;
    font-size: 14px;
    .tit{
      line-height: 32px;
      position: absolute;
      width: 160px;
      color: #8c8c8c;
      top: 0;
      left: 0;
      i{
        font-size: 16px;
      }
    }
    .val{
      width: 100%;
      position: relative;
      line-height: 32px;
      .stage-select{
        background: rgba(38,38,38,.05);
        color: #595959;
        height: 32px;
        cursor: pointer;
        border-radius: 4px;
        line-height: 32px;
        padding: 8px 10px 8px 15px;
        i{
          color: #bfbfbf;
        }
        &:hover{
          background: rgba(38,38,38,.13)
        }
      }
      .stage-success{
        background: rgba(21,173,49,.1);
        color: #038a24;
        i{
          color: #038a24;
        }
        &:hover{
          background: rgba(21,173,49,.15)
        }
      }
      .user-select{
        width: 100%;
        height: 32px;
        display: flex;
        justify-items: center;
        align-items: center;
        cursor: pointer;
        transition: background .3s ease;
        color: #262626;
        .name{
          margin-left: 8px;
        }
        &:hover{
          color: #409EFF;
        }
      }
      .task-reamrk{
        color: #262626;
        cursor: pointer;
        word-break: break-word;
      }
      .task-tag-add{
        font-size: 20px;
        cursor: pointer;
        color: #bfbfbf;
        &:hover{
          color: #409EFF;
        }
      }
    }
  }
}
.task-set-user-box{
  position: relative;
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  padding: 8px;
  margin-bottom: 10px;
  .user-select{
    display: flex;
    justify-items: center;
    align-items: center;
    cursor: pointer;
    &:hover{
      color: #409EFF;
    }
    .name{
      margin-left: 8px;
    }
  }
  .task-name{
    font-weight: bold;
  }
}
.task-set-time-box{
  position: relative;
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  padding: 8px;
  margin-bottom: 10px;
  .task-name{
    font-weight: bold;
  }
}
.task-dynamic-box{
  position: relative;
  border-left: 1px solid #E5E5E5;
  .dynamic-tab{
    width: 100%;
    position: relative;
    display: flex;
    justify-items: center;
    align-items: center;
    padding-left: 20px;
    .tab{
      padding: 0 8px;
      height: 28px;
      line-height: 28px;
      border-radius: 6px;
      margin-right: 8px;
      background: #F7F7F7;
      color: #595959;
      cursor: pointer;
      &:hover{
        background: #F2FBFF;
        color: #1B9AEE;
      }
    }
    .checked{
      background: #F2FBFF;
      color: #1B9AEE;
    }
  }
  .dynamic-list-box{
    width: 100%;
    position: relative;
    height: 400px;
    overflow: hidden;
    margin-top: 10px;
    padding-left: 20px;
    .dynamic-list{
      width: 100%;
      height: 100%;
      position: relative;
      overflow-x: hidden;
      overflow-y: auto;
      .not-dynamic{
        width: 100%;
        height: 400px;
        text-align: center;
        padding-top: 140px;
        .icon{
          color: rgb(198, 226, 255);
          font-size: 48px;
        }
        span{
          color: #8C8C8C;
          font-size: 13px;
        }
      }
      .dynamic-item{
        width: 100%;
        position: relative;
        margin: 10px 0 20px 0;
        padding-left: 38px;
        padding-right: 10px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
        }
        .right{
          width: 100%;
          position: relative;
          .tit{
            width: 100%;
            position: relative;
            display: flex;
            justify-items: center;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            color: #8C8C8C;
            padding-top: 4px;
            .txt{
              padding-right: 10px;
              span{
                margin-right: 8px;
              }
            }
          }
          .content{
            color: #595959;
            border-left: 4px solid #BFBFBF;
            margin-top: 8px;
            padding: 2px 0 2px 8px;
            font-size: 12px;
          }
          .file-list{
            margin-top: 8px;
            .file-item{
              width: 100%;
              position: relative;
              padding: 8px 8px 8px 28px;
              border-radius: 4px;
              cursor: pointer;
              -webkit-transition: background 218ms;
              -o-transition: background 218ms;
              transition: background 218ms;
              color: #595959;
              background: #F7F7F7;
              margin-bottom: 8px;
              &:last-child{
                margin-bottom: 0;
              }
              &:hover{
                background: #F0F0F0;
                .name{
                  color: #409EFF;
                }
              }
              .icon{
                width: 20px;
                height: 20px;
                position: absolute;
                left: 8px;
                top: 8px;
              }
              .name{
                width: 100%;
                padding-left: 8px;
                overflow: hidden;
                -o-text-overflow: ellipsis;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: normal;
                color: #595959;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
  .task-dynamic-input-box{
    border-top: 1px solid #E5E5E5;
    width: 100%;
    position: relative;
    padding-top: 8px;
    .btn-box{
      width: 100%;
      position: relative;
      padding-left: 14px;
      .up{
        cursor: pointer;
        i{
          font-size: 20px;
          color: #8c8c8c;
        }
        &:hover{
          i{
            color: #409EFF;
          }
        }
      }
      .btn{
        position: absolute;
        right: 0;
        top: -10px;
        display: flex;
        justify-items: center;
        align-items: center;
        .more{
          padding: 4px;
          cursor: pointer;
          &:hover{
            color: #409EFF;
            background: #F2FBFF;
          }
        }
      }
    }
  }
}
.dynamic-box{
  position: relative;
  height: calc(100% - 92px);
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  .task-dynamic-box2{
    position: relative;
    .dynamic-tab{
      width: 100%;
      position: relative;
      display: flex;
      justify-items: center;
      align-items: center;
      .tab{
        padding: 0 8px;
        height: 28px;
        line-height: 28px;
        border-radius: 6px;
        margin-right: 8px;
        background: #F7F7F7;
        color: #595959;
        cursor: pointer;
        &:hover{
          background: #F2FBFF;
          color: #1B9AEE;
        }
      }
      .checked{
        background: #F2FBFF;
        color: #1B9AEE;
      }
    }
    .dynamic-list-box{
      width: 100%;
      position: relative;
      margin-top: 10px;
      .dynamic-list{
        width: 100%;
        position: relative;
        .not-dynamic{
          width: 100%;
          height: 400px;
          text-align: center;
          padding-top: 140px;
          .icon{
            color: rgb(198, 226, 255);
            font-size: 48px;
          }
          span{
            color: #8C8C8C;
            font-size: 13px;
          }
        }
        .dynamic-item{
          width: 100%;
          position: relative;
          margin: 10px 0 20px 0;
          padding-left: 58px;
          padding-right: 10px;
          .photo{
            position: absolute;
            top: 0;
            left: 0;
          }
          .dynamic-info{
            width: 100%;
            position: relative;
            .tit{
              width: 100%;
              position: relative;
              font-size: 14px;
              color: #8C8C8C;
              padding-top: 4px;
              .txt{
                padding-right: 10px;
                span{
                  margin-right: 8px;
                }
              }
              .time{
                margin: 8px 0;
                font-size: 12px;
              }
            }
            .content{
              color: #595959;
              border-left: 4px solid #BFBFBF;
              margin-top: 8px;
              padding: 2px 0 2px 8px;
              font-size: 13px;
            }
            .file-list{
              margin-top: 8px;
              .file-item{
                position: relative;
                padding: 8px 8px 8px 28px;
                border-radius: 4px;
                cursor: pointer;
                -webkit-transition: background 218ms;
                -o-transition: background 218ms;
                transition: background 218ms;
                color: #595959;
                background: #F7F7F7;
                margin-bottom: 8px;
                &:last-child{
                  margin-bottom: 0;
                }
                &:hover{
                  background: #F0F0F0;
                  .name{
                    color: #409EFF;
                  }
                }
                .icon{
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  left: 8px;
                  top: 8px;
                }
                .name{
                  width: 100%;
                  padding-left: 8px;
                  overflow: hidden;
                  -o-text-overflow: ellipsis;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-wrap: normal;
                  color: #595959;
                  font-size: 13px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.file-header{
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-items: center;
  margin-bottom: 10px;
  .file-header-right{
    display: flex;
    justify-items: center;
    align-items: center
  }
}
.project-info{
  .info-box{
    width: 100%;
    position: relative;
    padding-left: 90px;
    padding-top: 10px;
    margin-bottom: 30px;
    .percent{
      position: absolute;
      left: 0;
      top: 0;
    }
    .name{
      font-size: 16px;
      color: #262626;
    }
    .time{
      font-size: 14px;
      margin-top: 10px;
      color: #8c8c8c;
    }
  }
  .info{
    width: 100%;
    position: relative;
    padding-left: 120px;
    font-size: 14px;
    margin-top: 14px;
    .tit{
      width: 120px;
      position: absolute;
      left: 0;
      top: 0;
      color: #8c8c8c;
      i{
        margin-right: 8px;
      }
    }
    .txt{
      width: 100%;
      position: relative;
      color: #262626;
    }
  }
  .overview-box{
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    .overview-item{
      border: 1px solid #ffffff;
      cursor: pointer;
      height: 110px;
      margin: 0px 16px 16px 0;
      padding: 12px;
      width: 164px;
      span{
        color: rgb(140, 140, 140);
        font-size: 12px;
        white-space: nowrap;
      }
      .num{
        color: #262626;
        margin: 4px 0;
        font-weight: bold;
        font-size: 32px;
      }
      &:hover{
        .num{
          color: #409EFF;
        }
      }
    }
    .active{
      border: 1px solid rgb(229, 229, 229);
      border-radius: 4px
    }
  }
}
</style>
